import {
  Injectable,
  DebugElement
} from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpEventType,
  HttpEvent
} from '@angular/common/http';
import {
  BehaviorSubject,
  Observable,
  of,
  throwError
} from "rxjs/index";
import {
  catchError,
  map,
  tap,
  retry
} from 'rxjs/operators';
import {
  ApiResponse
} from "../model/api.response";
import {
  Conta
} from '../model/conta';
import {
  PlatformLocation,
  DatePipe
} from '@angular/common';
import {
  AppService
} from '../app.service';
import {
  TranslateService
} from '@ngx-translate/core';
import {
  ToastrService
} from 'ngx-toastr';
import {
  Router
} from '@angular/router';
// https://www.npmjs.com/package/@ngx-pwa/local-storage
import {
  StorageMap,
  LocalStorage
} from '@ngx-pwa/local-storage';

// https://stackblitz.com/edit/ng-brazil?file=src%2Fapp%2Fapp.component.html
import * as textMaskAddons from 'text-mask-addons/dist/textMaskAddons';
import {
  Login
} from '../model/login';
import {
  Dicionario
} from '../model/dicionario';
import { DateFormatPipe } from 'ngx-moment';
import * as moment from 'moment';


import { addHours } from 'date-fns';
import { debug } from 'console';
import { environment } from 'src/environments/environment.development';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  hostName: any;
  hostPort: any;
  urlServerAPI: any;
  vernomecliente: boolean;
  login: Login;
  headers: any;
  isRemoteServer: boolean = false;
  isDev: boolean = false;

  dateMaskOptions = {
    mask: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
    pipe: textMaskAddons.createAutoCorrectedDatePipe('dd/mm/yyyy')
  };

  constructor(private router: Router, private translateService: TranslateService,
    private toastrService: ToastrService, private platformLocation: PlatformLocation,
    private appService: AppService, private http: HttpClient,
    private storage: StorageMap, protected localStorage: LocalStorage) {

    // https://stackoverflow.com/questions/49297680/angular-5-get-host-name-and-app-name-from-url
    // Example: localhost:4200
    this.hostName = (platformLocation as any).location.origin;
    // Example: 4200
    this.hostPort = (platformLocation as any).location.port;

    if (this.hostName.indexOf("dantdev") >= 0) {
      // indica que onde o sistema está executando - AWS
      this.isRemoteServer = true;

      // Hosting server
      this.vernomecliente = true;
      // HerokuApp
      //this.urlServerAPI = "https://app-dant.herokuapp.com/v1/";
      this.urlServerAPI = "https://legacy-api.dant.com.br/v1/";

    } else if (this.hostName.indexOf(".com") >= 0) {
      // indica que onde o sistema está executando - AWS
      this.isRemoteServer = true;

      // Hosting server
      this.vernomecliente = true;

      // AWS Lambda
      // antigo
      //this.urlServerAPI = "https://nnw94ic4uf.execute-api.us-east-1.amazonaws.com/v1/";

      // https://dashboard.heroku.com/apps/dantacesso-dev
      //this.urlServerAPI = "https://app-dant.herokuapp.com/v1/";

      // Elastic beanstalk = $29
      //this.urlServerAPI = "https://api.dantacesso.com.br/v1/";

      // HerokuApp = $7
      //this.urlServerAPI = "https://app-dant.herokuapp.com/v1/";
      this.urlServerAPI = "https://legacy-api.dant.com.br/v1/";

      //this.urlServerAPI = "https://sea-lion-app-bga32.ondigitalocean.app/v1/"
      //this.urlServerAPI = "https://api.dant.com.br/v1/"

    } else if (this.hostPort == 4200/* || this.hostName.indexOf("localhost") >= 0/**/) {

      // indica que onde o sistema está executando - AWS
      this.isRemoteServer = environment.IS_REMOTE_SERVER;
      // Ambiente de desenvolvimento
      this.vernomecliente = environment.VER_NOME_CLIENTE;
      //this.urlServerAPI = "http://localhost/v1/";
      this.urlServerAPI = environment.API_URL;
      //this.urlServerAPI = "http://localhost/v1/";
      //this.urlServerAPI = "https://app-dant.herokuapp.com/v1/"
      //this.urlServerAPI = "https://api.dant.com.br/v1/";
      //this.urlServerAPI = "https://sea-lion-app-bga32.ondigitalocean.app/v1/";

      this.isDev = true;

    } else {
      this.isRemoteServer = false;
      // Hosting local do cliente
      this.vernomecliente = false;
      // Via URL atual do browser
      this.urlServerAPI = "/v1/";
    }

    //this.getUser();

    this.getDispositivosStatus()
  }

  ngOnInit() {


  }

  public async getUser(): Promise<Login> {

    try {

      if (!this.login) {

        let data = await this.localStorage.getItem<Login>('login').toPromise();

        if (!data) {
          // usuario está sem sessão
          // Redirect to session expired
          this.router.navigate(['/login/authentication/login-v2']);

          return null;

        }

        let user = data as Login;

        this.login = new Login(user, user.idcliente_remote, user.cli_modoconexao, user.cli_conexao);

        let newLogin: any = await this.localStorage.getItem<any>('TOKEN_GCP').toPromise();

        if (newLogin) {
          environment.TEMP_TOKEN_GCP = `Bearer ${newLogin.accessToken}`
        }

        this.setHeaders();

      }

      return this.login;

    } catch (e) {
      console.log('getUser: ', e);

      // usuario está sem sessão
      // Redirect to session expired
      this.router.navigate(['/login/authentication/login-v2']);

      return null;

    }
  }



  public async getHeaders(): Promise<any> {

    if (!this.login) {
      await this.getUser();
    }

    return this.headers;

  }

  setHeaders() {
    if (this.login?.cli_modoconexao) {

      this.headers = {
        'Content-Type': 'application/json',
        'x-access-token': this.login.token,
        'fk-idcliente': this.login.idcliente_remote,
        'cli-modoconexao': this.login.cli_modoconexao,
        'cli-conexao': this.login.cli_conexao,
        'Authorization': `Bearer ${this.login.token}`,
      }

      if (!this.headers['cli-modoconexao']) {
        delete this.headers['cli-modoconexao']
      }

      if (!this.headers['cli-conexao']) {
        delete this.headers['cli-conexao']
      }

    } else {

      this.headers = {
        'Content-Type': 'application/json',
        'x-access-token': this.login?.token,
        'fk-idcliente': this.login?.idcliente_remote || "1",
        'Authorization': `Bearer ${this.login?.token}`,
      }
    }
  }

  tapToDismiss = true;
  closeButton = false;
  progressBar = true;
  preventDuplicates = false;
  newestOnTop = false;
  progressAnimation = 'decreasing';
  positionClass = 'toast-bottom-right';

  /**
   * 
   * @param keyTranslate 
   * @param type -> 'success', 'error', 'info'
   */
  showToast(keyTitleTranslate: string = null, keyMessageTranslate: any, type: string, positionClass = 'toast-bottom-right') {

    const options = {
      tapToDismiss: this.tapToDismiss,
      closeButton: this.closeButton,
      progressBar: this.progressBar,
      progressAnimation: this.progressAnimation,
      positionClass: positionClass,
      rtl: this.appService.isRTL
    };

    // `newestOnTop` and `preventDuplicates` options must be set on global config
    this.toastrService.toastrConfig.newestOnTop = this.newestOnTop;
    this.toastrService.toastrConfig.preventDuplicates = this.preventDuplicates;

    this.translateService.get(keyMessageTranslate).subscribe(messageTranslated => {

      if (!keyTitleTranslate) {
        this.toastrService[type](messageTranslated, null, options);
      } else {
        this.translateService.get(keyTitleTranslate).subscribe(titleTranslated => {

          this.toastrService[type](messageTranslated, titleTranslated, options);

        });
      }

    });

  }


  errorMessageShow(data: any) {

    var codeError = null;

    if (typeof data === 'string') {
      codeError = data;
    } else if (data && (data.status == 0 || (data.error && data.error.response && data.error.response.message == 1000))) {
      // Não há conexao
      codeError = "1000";
    } else if (!data || !data.error || data.status == 500) {
      // Erro interno
      codeError = "500";
      console.error(data);
    } else if (data.error.response && data.error.response.code) {

      codeError = data.error.response.code.toString();

    } else if (data.error.errors) {
      // Multiplos erros encontrado na validação do form
      // Exibindo multiplas mensagens de erros
      for (let index = 0; index < data.error.errors.length; index++) {

        const element = data.error.errors[index];

        this.showToast("error.info", element.code.toString(), 'info', 'toast-top-right');

      }

    }

    if (codeError) {

      this.showToast(null, codeError, 'error', 'toast-top-right');

    }

  }

  // API Backend - DantAcesso

  get getRowLimit() {
    return 20;
  }


  //#region CONTAS

  loadContas(body: any) {


  }


  checkConta(body: any) {

    if (body.con_locais) {
      body.con_locais = body.con_locais.toString(); // array.toString(); // '1,2,3'    
    }

    if (body.con_locais == "0") {
      body.con_locais = null;
    }

    if (body.con_empresas) {
      body.con_empresas = body.con_empresas.toString(); // array.toString(); // '1,2,3'    
    }

    if (body.con_empresas == "0") {
      body.con_empresas = null;
    }

    if (body.con_fornecedores) {
      body.con_fornecedores = body.con_fornecedores.toString(); // array.toString(); // '1,2,3'    
    }

    if (body.con_fornecedores == "0") {
      body.con_fornecedores = null;
    }

    /*if (body.fk_idempresa == 0) {
      body.fk_idempresa = null;
    }/**/

  }

  /**
   * Contas de Usuário
   * @param operation 
   * @param result 
   */

  async createConta(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "contas/";

      this.checkConta(body);

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'createConta');
    }

    return retorno;

  }

  async updateConta(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "contas/" + body.pk_idconta;

      this.checkConta(body);

      retorno = await this.http.put<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'updateConta');
    }

    return retorno;

  }

  async patchConta(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "contas/" + body.pk_idconta;

      this.checkConta(body);

      retorno = await this.http.patch<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'patchConta');
    }

    return retorno;

  }

  async removeConta(id: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "contas/" + id;

      await this.http.delete<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'removeConta');
    }

    return retorno;

  }

  async getContaPorID(id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "contas/" + id;

      retorno = await this.http.get<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

      let data = retorno.response[0];

      data.con_datahora = this.dateIsoToString(data.con_datahora);

      if (data.con_locais) {
        // convert to array of int        
        data.con_locais = data.con_locais.split(',').map(function (item) {
          return parseInt(item, 10);
        });

        data.con_locaisdeacesso_json = this.stringToJSON(data.con_locaisdeacesso_json);
      } else {
        data.con_locais = [0];
      }

      if (data.con_empresas) {
        // convert to array of int        
        data.con_empresas = data.con_empresas.split(',').map(function (item) {
          return parseInt(item, 10);
        });

        data.con_empresas_json = this.stringToJSON(data.con_empresas_json);

      } else {
        data.con_empresas = [0];
      }

      if (data.con_fornecedores) {
        // convert to array of int        
        data.con_fornecedores = data.con_fornecedores.split(',').map(function (item) {
          return parseInt(item, 10);
        });
      } else {
        data.con_fornecedores = [0];
      }

      /*if (data.fk_idempresa == null) {
        data.fk_idempresa = 0;
      } /**/

    } catch (error) {
      this.handleError(error, 'getContaPorID');
    }

    return retorno;

  }

  async getContas(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_contas",
        this.login.idCliente,
        params.searchQuery,
        this.login.conta.gru_hierarquia, // hierarquia
        params.empresa && params.empresa[0] != '0' ? params.empresa.toString() : null, //separado por virgula .toString(); // array.toString(); // '1,2,3'
        params.grupo, // id grupo
        (!params.status || params.status.length == 2) ? null : params.status[0],
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getContas');
    }

    return retorno;

  }
  /**
   * Produtos
   * @param operation 
   * @param result 
   */

  checkProduto(body: any) {

    if (body.con_locais) {
      body.con_locais = body.con_locais.toString(); // array.toString(); // '1,2,3'    
    }

    if (body.con_locais == "0") {
      body.con_locais = null;
    }

    if (body.con_empresas) {
      body.con_empresas = body.con_empresas.toString(); // array.toString(); // '1,2,3'    
    }

    if (body.con_empresas == "0") {
      body.con_empresas = null;
    }

    if (body.con_fornecedores) {
      body.con_fornecedores = body.con_fornecedores.toString(); // array.toString(); // '1,2,3'    
    }

    if (body.con_fornecedores == "0") {
      body.con_fornecedores = null;
    }

    /*if (body.fk_idempresa == 0) {
      body.fk_idempresa = null;
    }/**/

  }

  async createProduto(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "produtos/";

      this.checkProduto(body);

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'createProduto');
    }

    return retorno;

  }

  async updateProduto(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "produtos/" + body.pk_idproduto;

      this.checkProduto(body);

      retorno = await this.http.put<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'updateProduto');
    }

    return retorno;

  }

  async patchProduto(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "produtos/" + body.pk_idproduto;

      this.checkProduto(body);

      retorno = await this.http.patch<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'patchProduto');
    }

    return retorno;

  }

  async removeProduto(id: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "produtos/" + id;

      await this.http.delete<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'removeProduto');
    }

    return retorno;

  }

  async getProdutoPorID(id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "produtos/" + id;

      retorno = await this.http.get<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

      let data = retorno.response[0];

      data.pro_datahora = this.dateIsoToString(data.pro_datahora);



      /*if (data.fk_idempresa == null) {
        data.fk_idempresa = 0;
      } /**/

    } catch (error) {
      this.handleError(error, 'getProdutoPorID');
    }

    return retorno;

  }

  async getProdutos(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        this.login.idCliente,
        params.searchQuery,
        params.empresa && params.empresa[0] != '0' ? params.empresa.toString() : null, //separado por virgula .toString(); // array.toString(); // '1,2,3'
        (!params.status || params.status.length == 2) ? null : params.status[0],
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]


      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getPerfisdeacessos');
    }

    return retorno;

  }
  /**
   * Estoques
   * @param operation 
   * @param result 
   */

  checkStock(body: any) {

    if (body.con_locais) {
      body.con_locais = body.con_locais.toString(); // array.toString(); // '1,2,3'    
    }

    if (body.con_locais == "0") {
      body.con_locais = null;
    }

    if (body.con_empresas) {
      body.con_empresas = body.con_empresas.toString(); // array.toString(); // '1,2,3'    
    }

    if (body.con_empresas == "0") {
      body.con_empresas = null;
    }

    if (body.con_fornecedores) {
      body.con_fornecedores = body.con_fornecedores.toString(); // array.toString(); // '1,2,3'    
    }

    if (body.con_fornecedores == "0") {
      body.con_fornecedores = null;
    }

    /*if (body.fk_idempresa == 0) {
      body.fk_idempresa = null;
    }/**/

  }

  async createStock(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "estoques/";

      this.checkStock(body);

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'createStocks');
    }

    return retorno;

  }

  async updateStock(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "estoques/" + body.pk_idestoque;

      this.checkStock(body);

      retorno = await this.http.put<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'updateStock');
    }

    return retorno;

  }

  async patchStock(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "estoques/" + body.pk_idestoque;

      this.checkStock(body);

      retorno = await this.http.patch<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'patchStock');
    }

    return retorno;

  }

  async removeStock(id: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "estoques/" + id;

      await this.http.delete<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'removeStock');
    }

    return retorno;

  }

  async getStockPorID(id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "estoques/" + id;

      retorno = await this.http.get<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

      let data = retorno.response[0];

      //data.pro_datahora = this.dateIsoToString(data.pro_datahora);



      /*if (data.fk_idempresa == null) {
        data.fk_idempresa = 0;
      } /**/

    } catch (error) {
      this.handleError(error, 'getProdutoPorID');
    }

    return retorno;

  }

  async getStocks(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_estoques",
        this.login.idCliente,
        params.searchQuery,
        params.empresa && params.empresa[0] != '0' ? params.empresa.toString() : null, //separado por virgula .toString(); // array.toString(); // '1,2,3'
        (!params.status || params.status.length == 2) ? null : params.status[0],
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]


      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getPerfisdeacessos');
    }

    return retorno;

  }

  async getContasChat(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_contas_chat",
        this.login.idCliente,
        params.searchQuery,
        params.fk_idconta_emissor,
        this.getRowLimit, //max_limit INT, 
        params.offset
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();


      retorno.response.forEach(o => {
        o.img = this.generateUrlImage("conta", o.pk_idconta);
      });

    } catch (error) {
      this.handleError(error, 'getContasChat');
    }

    return retorno;

  }

  getHeadersIdCliente(clienteSelecionado): any {

    let idcliente_remote = '1';
    let idcliente = '1';

    let cli_modoconexao = ''; // default banco local

    if (clienteSelecionado) {

      cli_modoconexao = clienteSelecionado.cli_modoconexao;

      // Banco de dados local
      if (cli_modoconexao == 'L' || cli_modoconexao == 'C') {
        idcliente_remote = clienteSelecionado.pk_idcliente;

        if (this.isRemoteServer && cli_modoconexao == 'C') {
          idcliente = idcliente_remote;

        }
      } else {
        idcliente_remote = clienteSelecionado.pk_idcliente;
        idcliente = clienteSelecionado.pk_idcliente;

      }

    }

    let headers: any = {
      'Content-Type': 'application/json',
      'fk-idcliente': idcliente_remote.toString(),
    }

    if (clienteSelecionado) {
      headers = {
        ...headers,
        'cli-modoconexao': cli_modoconexao || null,
        'cli-conexao': clienteSelecionado?.cli_conexao || null
      }

      if (!headers['cli-conexao']) {
        delete headers['cli-conexao']
      }
    }

    return headers
  }

  async loginConta(clienteSelecionado, loginPayload): Promise<ApiResponse> {

    var retorno = null;

    try {

      let headers = this.getHeadersIdCliente(clienteSelecionado)

      var body = loginPayload

      const urlAPI = this.urlServerAPI + "contas/login"

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise()

      this.loadContas(retorno)

      this.login = new Login(retorno.response, headers['fk-idcliente'], headers['cli-modoconexao'], headers['cli-conexao'])

      this.clearStorageLocal();

      this.setHeaders()

      this.setStorageLocal('login', this.login)

    } catch (error) {
      this.handleError(error, 'loginConta');
    }

    return retorno;

  }

  async recuperarSenha(clienteSelecionado, loginPayload): Promise<ApiResponse> {

    var retorno = null;

    try {

      let headers = this.getHeadersIdCliente(clienteSelecionado)

      //let idclienteLocal = headers['fk-idcliente-local']

      //delete headers['fk-idcliente-local']

      var body = [
        "view_recuperar_senha",
        clienteSelecionado?.fk_idcliente || 1,
        loginPayload.con_login
      ]

      const urlAPI = this.urlServerAPI + "sql_views_sem_token";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'recuperarSenha');
    }

    return retorno;

  }

  async logout(isClearSession: boolean = true) {

    try {

      var user = await this.getUser();

      user.sessionExpired = true;

      // Registrando a saída do usuario do sistema em banco de dados
      this.createLogAcesso(user);

    } catch (error) {
      console.log('logout: ' + error);
    } finally {
      if (isClearSession == true) {
        // Limpando todos os dados salvos localmente
        this.clearStorageLocal();

        this.login = null;

        this.router.navigate(['/login/authentication/login-v2']);
      }
    }

  }

  /**
   * Buscar contas por e-mail - No login
   * @param operation 
   * @param result 
   */

  async getContasPorEmail(idcliente: number, email: string): Promise<ApiResponse> {

    var retorno = null;

    try {

      let headers = {
        'Content-Type': 'application/json',
        'fk-idcliente': idcliente.toString()
      }

      var body = [
        "view_contas",
        idcliente > 0 ? idcliente : 1, // pk_idcliente INT, 
        email, // Nome ou Email VARCHAR, 
        0, // hierarquia INT, 
        0, // idempresa INT, 
        0, // idgrupo INT, 
        'A', // status CHAR, 
        this.getRowLimit, //max_limit INT, 
        0, // pos_offset INT, 
        'con_login', // orderby VARCHAR, 
        'ASC' // direction VARCHAR
      ]

      const urlAPI = this.urlServerAPI + "sql_views_sem_token";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getContasPorEmail');
    }

    return retorno;
  }

  /**
   * Buscar contas por e-mail - No login
   * @param operation 
   * @param result 
   */

  async getContasPorEmailUserLogged(email: string): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_contas",
        this.login.idCliente,
        email, // Nome ou Email VARCHAR, 
        0, // hierarquia INT, 
        0, // idempresa INT, 
        0, // idgrupo INT, 
        'A', // status CHAR, 
        this.getRowLimit, //max_limit INT, 
        0, // pos_offset INT, 
        'con_login', // orderby VARCHAR, 
        'ASC' // direction VARCHAR
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getContasPorEmail');
    }

    return retorno;
  }

  /**
   * Buscar contas por e-mail - No login
   * @param operation 
   * @param result 
   */

  async getContasLogin(clienteSelecionado: any = null, email: string): Promise<ApiResponse> {

    var retorno = null;

    try {


      let idcliente_remote = '1';
      let idcliente = '1';

      let cli_modoconexao = ''; // default banco local

      if (clienteSelecionado) {

        cli_modoconexao = clienteSelecionado.cli_modoconexao;

        // Banco de dados local
        if (cli_modoconexao == 'L' || cli_modoconexao == 'C') {
          idcliente_remote = clienteSelecionado.pk_idcliente;

          if (this.isRemoteServer && cli_modoconexao == 'C') {
            idcliente = idcliente_remote;

          }
        } else {
          idcliente_remote = clienteSelecionado.pk_idcliente;
          idcliente = clienteSelecionado.pk_idcliente;

        }

      }

      let headers: any = {
        'Content-Type': 'application/json',
        'fk-idcliente': idcliente_remote.toString(),
      }

      if (clienteSelecionado) {
        headers = {
          ...headers,
          'cli-modoconexao': cli_modoconexao || null,
          'cli-conexao': clienteSelecionado?.cli_conexao || null
        }

        if (!headers['cli-conexao']) {
          delete headers['cli-conexao']
        }
      }


      var body = [
        "view_contas",
        idcliente, // pk_idcliente INT, 
        email, // Nome ou Email VARCHAR, 
        0, // hierarquia INT, 
        0, // idempresa INT, 
        0, // idgrupo INT, 
        'A', // status CHAR, 
        2, //max_limit INT, 
        0, // pos_offset INT, 
        'con_login', // orderby VARCHAR, 
        'ASC' // direction VARCHAR
      ]

      const urlAPI = this.urlServerAPI + "sql_views_sem_token";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getContasPorEmail');
    }

    return retorno;
  }

  async sendEmail(bodyEmail, clienteSelecionado = null): Promise<ApiResponse> {

    var retorno = null;

    try {


      let headers

      if (clienteSelecionado) {

        headers = this.getHeadersIdCliente(clienteSelecionado)

      } else {
        headers = await this.getHeaders()
      }

      const urlAPI = this.urlServerAPI + "sendemail";

      await this.http.post<ApiResponse>(urlAPI, bodyEmail, {
        headers
      }).toPromise();

      // 204 - No Content
      retorno = {};

    } catch (error) {
      this.handleError(error, 'sendEmail');
    }

    return retorno;

  }

  async createLogAcesso(user: Login): Promise<ApiResponse> {

    var retorno = null;

    try {

      // O registro de log nao pode depender de token, pois a sessao pode ter sido expirada. Entao como fica o registro do log de saída de sistema sem token valido?

      const headers = await this.getHeaders();

      var body = {
        "fk_idcliente": user.idCliente,
        "fk_idconta": user.conta.pk_idconta,
        "log_entradasaida": "S"
      }

      const urlAPI = this.urlServerAPI + "logacessos";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {

    }

    return retorno;

  }

  //#endregion


  //#region CHATS

  loadChats(body: any) {


  }


  checkChat(body: any) {


  }

  /**
   * Chats de Usuário
   * @param operation 
   * @param result 
   */

  async createChat(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "chats/";

      this.checkChat(body);

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'createChat');
    }

    return retorno;

  }

  async updateChat(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "chats/" + body.pk_idchat;

      this.checkChat(body);

      retorno = await this.http.put<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'updateChat');
    }

    return retorno;

  }

  async patchChat(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "chats/" + body.pk_idchat;

      this.checkChat(body);

      retorno = await this.http.patch<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'patchChat');
    }

    return retorno;

  }

  async removeChat(id: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "chats/" + id;

      await this.http.delete<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'removeChat');
    }

    return retorno;

  }

  async getChatPorID(id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "chats/" + id;

      retorno = await this.http.get<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

      let data = retorno.response[0];

      data.cha_datahora = this.dateIsoToString(data.cha_datahora);


    } catch (error) {
      this.handleError(error, 'getChatPorID');
    }

    return retorno;

  }

  async getChats(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_chats",
        this.login.idCliente,
        params.searchQuery,
        params.fk_idconta_emissor,
        params.fk_idconta_receptor,
        params.ultimo_id,
        this.getRowLimit, //max_limit INT, 
        params.offset
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getChats');
    }

    return retorno;

  }

  /**
   * Buscar chats por e-mail - No login
   * @param operation 
   * @param result 
   */

  async getChatsPorEmail(idcliente: number, email: string): Promise<ApiResponse> {

    var retorno = null;

    try {

      let headers = {
        'Content-Type': 'application/json',
        'fk-idcliente': idcliente.toString()
      }

      var body = [
        "view_chats",
        idcliente > 0 ? idcliente : 1, // pk_idcliente INT, 
        email, // Nome ou Email VARCHAR, 
        0, // hierarquia INT, 
        0, // idempresa INT, 
        0, // idgrupo INT, 
        'A', // status CHAR, 
        2, //max_limit INT, 
        0, // pos_offset INT, 
        'cha_login', // orderby VARCHAR, 
        'ASC' // direction VARCHAR
      ]

      const urlAPI = this.urlServerAPI + "sql_views_sem_token";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getChatsPorEmail');
    }

    return retorno;
  }
  //#endregion


  //#region Cliente
  checkCliente(body: any) {

    body.cli_cpf_cnpj = this.getOnlyNumbers(body.cli_cpf_cnpj);
    body.cli_cep = this.getOnlyNumbers(body.cli_cep);

    body.cli_telefone = this.jsonToString(body.cli_telefone);
    body.cli_email = this.jsonToString(body.cli_email);

  }

  /**
   * Clientes
   * @param operation 
   * @param result 
   */

  async createCliente(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "clientes/";

      this.checkCliente(body);

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'createCliente');
    }

    return retorno;

  }

  async updateCliente(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "clientes/" + body.pk_idcliente;

      this.checkCliente(body);

      retorno = await this.http.put<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'updateCliente');
    }

    return retorno;

  }

  async removeCliente(id: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "clientes/" + id;

      await this.http.delete<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'removeCliente');
    }

    return retorno;

  }

  async getClientePorID(id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "clientes/" + id;

      retorno = await this.http.get<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

      // converte para array
      retorno.response[0].cli_telefone = this.stringToJSON(retorno.response[0].cli_telefone);
      retorno.response[0].cli_email = this.stringToJSON(retorno.response[0].cli_email);

      // converte data to language      
      //retorno.response[0].cli_validade = this.dateIsoToString(retorno.response[0].cli_validade);
      retorno.response[0].cli_datafundacao = this.dateIsoToString(retorno.response[0].cli_datafundacao);
      retorno.response[0].cli_datahora = this.dateIsoToString(retorno.response[0].cli_datahora);

    } catch (error) {
      this.handleError(error, 'getClientePorID');
    }

    return retorno;

  }

  async getClientesPorNomeOuID(pesq): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = {
        'Content-Type': 'application/json',
        'fk-idcliente': '0',
        'cli-modoconexao': 'C' // default banco local compartilhado

      }

      var body = [
        "view_clientes_por_id_ou_nome",
        pesq, // pesq VARCHAR, 
        2, //max_limit INT
      ]

      const urlAPI = this.urlServerAPI + "sql_views_sem_token";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getClientesPorNomeOuID');
    }

    return retorno;

  }

  async getClientes(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_clientes",
        params.searchQuery,
        params.dataInicio, // validade_inicio
        params.dataFim, // validade_fim
        params.contrato,
        (!params.status || params.status.length == 2) ? null : params.status[0],
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getClientes');
    }

    return retorno;

  }

  //#endregion


  //#region Usuario: Aluno, Morador, Funcionario, Visitante, Convidado
  checkUsuario(body: any) {

    if (body.usu_locaisdeacesso) {
      body.usu_locaisdeacesso = body.usu_locaisdeacesso.toString(); // array.toString(); // '1,2,3'

      if (body.usu_locaisdeacesso == '0') {
        body.usu_locaisdeacesso = null;
      }
    }

    if (body.usu_tiposservicos) {
      body.usu_tiposservicos = body.usu_tiposservicos.toString(); // array.toString(); // '1,2,3'
    }

    if (body.usu_fornecedores) {
      body.usu_fornecedores = body.usu_fornecedores.toString(); // array.toString(); // '1,2,3'
    }

    body.usu_documento = this.getOnlyNumbers(body.usu_documento);
    body.usu_documento2 = this.removeAllSpacesAndAccent(body.usu_documento2); // Tem clientes que cadastram com a sigla SSP/PE no RG ou ADVOGADO, EX.: 15013OABPE
    body.usu_matricula = this.getOnlyNumbers(body.usu_matricula);

    // Removendo espacos duplos
    body.usu_nome = this.removeSpacesAndAccent(body.usu_nome)
    //body.usu_email = this.jsonToString(body.usu_email);

  }

  loadUsuario(body: any) {

    let o = body.response[0];

    if (o.usu_locaisdeacesso == '0') {
      o.usu_locaisdeacesso = null;
    }

    if (o.usu_locaisdeacesso) {
      // convert to array of int        
      o.usu_locaisdeacesso = o.usu_locaisdeacesso.split(',').map(function (item) {
        return parseInt(item, 10);
      });

    }

    if (o.usu_tiposservicos) {
      // convert to array of int        
      o.usu_tiposservicos = o.usu_tiposservicos.split(',').map(function (item) {
        return parseInt(item, 10);
      });

    }

    if (o.usu_fornecedores) {
      // convert to array of int        
      o.usu_fornecedores = o.usu_fornecedores.split(',').map(function (item) {
        return parseInt(item, 10);
      });

    }

    // converte data to language      
    o.usu_datahora = this.dateIsoToString(o.usu_datahora);

    o.locaisdeacesso_json = this.stringToJSON(o.locaisdeacesso_json);
    o.autorizacoes_json = this.stringToJSON(o.autorizacoes_json);
    o.cartoes_json = this.stringToJSON(o.cartoes_json);
    o.biometrias_json = this.stringToJSON(o.biometrias_json);
    o.biometriasfacial_json = this.stringToJSON(o.biometriasfacial_json);
    o.veiculos_json = this.stringToJSON(o.veiculos_json);
    o.telefones_json = this.stringToJSON(o.telefones_json);
    o.objetos_json = this.stringToJSON(o.objetos_json);
    o.animais_json = this.stringToJSON(o.animais_json);
    o.bloqueios_json = this.stringToJSON(o.bloqueios_json);
    o.documentos_json = this.stringToJSON(o.documentos_json);
    o.tiposservicos_json = this.stringToJSON(o.tiposservicos_json);
    o.fornecedores_json = this.stringToJSON(o.fornecedores_json);


    if (o.biometriasfacial_json) {

      o.biometriasfacial_json.forEach(element => {

        element.img = this.generateUrlImage("tag", element.pk_idtag);

      });

    }

    if (o.documentos_json) {

      o.documentos_json.forEach(element => {

        element.img = this.generateUrlImage("documento", element.pk_iddocumento);

      });

    }

    if (o.objetos_json) {

      o.objetos_json.forEach(element => {

        element.img = this.generateUrlImage("objeto", element.pk_idobjeto);

      });

    }

    if (o.animais_json) {

      o.animais_json.forEach(element => {

        element.img = this.generateUrlImage("animal", element.pk_idanimal);

      });

    }

    this.loadAutorizacoes(o.autorizacoes_json);

  }


  checkStaff(body: any) {

    if (body.con_locais) {
      body.con_locais = body.con_locais.toString(); // array.toString(); // '1,2,3'    
    }

    if (body.con_locais == "0") {
      body.con_locais = null;
    }

    if (body.con_empresas) {
      body.con_empresas = body.con_empresas.toString(); // array.toString(); // '1,2,3'    
    }

    if (body.con_empresas == "0") {
      body.con_empresas = null;
    }

    if (body.con_fornecedores) {
      body.con_fornecedores = body.con_fornecedores.toString(); // array.toString(); // '1,2,3'    
    }

    if (body.con_fornecedores == "0") {
      body.con_fornecedores = null;
    }

    /*if (body.fk_idempresa == 0) {
      body.fk_idempresa = null;
    }/**/

  }

  async createStaff(body: any): Promise<ApiResponse> {

    var retorno = null;


    debugger

    const headers = await this.getHeaders();

    const urlAPI = this.urlServerAPI + "staffs";

    // this.checkProduto(body);

    retorno = await this.http.post<ApiResponse>(urlAPI, body).toPromise();


    return retorno;

  }

  async createVisitante(params: any, pk_idcliente: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      let clienteSelecionado = {
        pk_idcliente: pk_idcliente,
        cli_modoconexao: 'L'
      }

      let headers = this.getHeadersIdCliente(clienteSelecionado)

      var body = [
        "convite",
        this.getOnlyNumbers(params.usu_documento),
        this.getOnlyNumbers(params.usu_documento2),
        params.usu_nome,
        params.usu_email,
        this.getOnlyNumbers(params.usu_telefone),
        params.usu_datanascimento,
        params.fk_idsetor,
        params.fk_idvinculo,
        params.evi_data_visita,
        params.evi_idquemautorizou
      ]

      const urlAPI = this.urlServerAPI + "sql_views_sem_token";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'createVisitante');
    }

    return retorno;

  }

  /**
   * Usuarios
   * @param operation 
   * @param result 
   */

  async createUsuario(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "usuarios/";

      this.checkUsuario(body);

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'createUsuario');
    }

    return retorno;

  }

  async updateUsuario(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "usuarios/" + id;

      this.checkUsuario(body);

      retorno = await this.http.put<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'updateUsuario');
    }

    return retorno;

  }

  async removeUsuario(id: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "usuarios/" + id;

      await this.http.delete<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'removeUsuario');
    }

    return retorno;

  }

  async getUsuarioPorID(id: number = null, cpf: string = null): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_pessoa_id_ou_cpf",
        this.login.idCliente,
        id, // pk_idusuario
        cpf // usu_documento = CPF
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

      this.loadUsuario(retorno);

    } catch (error) {
      this.handleError(error, 'getUsuarioPorID');
    }

    return retorno;

  }

  async getUsuariosPorDocumento(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_usuarios_por_documento", // rg
        this.login.idCliente,
        params.searchQuery, // pesq VARCHAR,
        this.getRowLimit, //max_limit INT, 
        params.offset
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getUsuariosPorDocumento');
    }

    return retorno;

  }

  async getUsuarios(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_usuarios",
        this.login.idCliente,
        params.searchQuery,
        params.idperfisdeacesso, // perfil de acesso
        params.empresa && params.empresa[0] != '0' ? params.empresa.toString() : null, //separado por virgula .toString(); // array.toString(); // '1,2,3'
        params.setor, // id grupo
        // params.vinculo ? params.vinculo : null,
        (!params.status || params.status.length == 2) ? null : params.status[0],
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy.toString(),
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getUsuarios');
    }

    return retorno;

  }

  async getUsuariosPorSetorNomeEPerfil(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      params.searchQuery = this.removeSpacesAndAccent(params.searchQuery)

      var body = [
        "view_pessoas",
        this.login.idCliente,
        params.searchQuery,
        params.empresa, // id empresa
        params.setor, // id setor        
        params.idperfisdeacesso && params.idperfisdeacesso[0] > 0 ? params.idperfisdeacesso.toString() : null, //separado por virgula .toString(); // array.toString(); // '1,2,3'    
        params.status,
        params.rowLimit ? params.rowLimit : this.getRowLimit, //max_limit INT,
        params.offset
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

      if (retorno) {
        retorno.response.forEach(o => {
          o.veiculo_json = this.stringToJSON(o.veiculo_json);
        })
      }

    } catch (error) {
      this.handleError(error, 'getUsuariosPorSetorNomeEPerfil');
    }

    return retorno;

  }

  async importUsuarios(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "import_usuarios",
        params.rows
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'importUsuarios');
    }

    return retorno;

  }

  //#endregion

  //#region EMPRESA_VISITANTE

  async loadAutorizacoes(autorizacoes_json) {

    if (autorizacoes_json) {
      autorizacoes_json.forEach(a => {

        try {
          if (a.locaisdeacesso_json) {
            a.locaisdeacesso_json = this.stringToJSON(a.locaisdeacesso_json);
          }

          if (a.autorizadopor_json) {
            a.autorizadopor_json = this.stringToJSON(a.autorizadopor_json);
          }

          if (a.evi_locaisdeacesso) {
            // convert to array of int        
            a.evi_locaisdeacesso = a.evi_locaisdeacesso.split(',').map(function (item) {
              return parseInt(item, 10);
            });
          }

        } catch (error) {
          console.log('loadAutorizacoes: ' + error);
        }

      });
    }
  }

  /**
   * Empresa Visitante - Autorazacoes de acesso
   * @param operation 
   * @param result 
   */

  async createEmpresaVisitante(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "empresavisitantes/";

      body.evi_descricao = this.removeSpacesAndAccent(body.evi_descricao)

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'createEmpresaVisitante');
    }

    return retorno;

  }

  async updateEmpresaVisitante(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "empresavisitantes/" + body.pk_idempresavisitante;

      retorno = await this.http.put<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'updateEmpresaVisitante');
    }

    return retorno;

  }

  async removeEmpresaVisitante(id: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "empresavisitantes/" + id;

      await this.http.delete<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'removeEmpresaVisitante');
    }

    return retorno;

  }

  async getEmpresaVisitantePorID(id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "empresavisitantes/" + id;

      retorno = await this.http.get<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getEmpresaVisitantePorID');
    }

    return retorno;

  }

  async getViewAutorizacoes(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_autorizacoes",
        this.login.idCliente,
        params.searchQuery,
        params.empresa && params.empresa[0] != '0' ? params.empresa.toString() : null, //separado por virgula .toString(); // array.toString(); // '1,2,3'
        params.setor, // id grupo
        params.validade,
        params.numerodias,
        (!params.status || params.status.length == 2) ? null : params.status[0],
        this.getRowLimit, //max_limit INT, 
        params.offset
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

      retorno.response.forEach(o => {

        o.img = this.getUrlImage(o.image, true);

        try {

          //o.autorizacoes = [this.stringToJSON(o.autorizacoes_json)];
          o.autorizacoes = this.stringToJSON(o.autorizacoes_json);

          o.countautorizacao = 0;

          if (o.autorizacoes) {
            // Contando as autorizacoes validas
            // Autorizados e Futuros

            o.autorizacoes.forEach(a => {

              a.evi_validade_inicio = this.dateIsoToString(a.evi_validade_inicio, 'short');
              a.evi_validade_fim = this.dateIsoToString(a.evi_validade_fim, 'short');

              if (a.situacao == '0' || a.situacao == '1') {
                o.countautorizacao++;
              }
            });
          }

        } catch (e) {
          console.log(e);
        }

      });

    } catch (error) {
      this.handleError(error, 'getViewAutorizacoes');
    }

    return retorno;

  }

  async getAutorizacaoPorIdUsuario(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_autorizacao_id_usuario",
        params.idusuario,
        params.situacao // validade
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

      this.loadAutorizacoes(retorno.response);

    } catch (error) {
      this.handleError(error, 'getAutorizacaoPorIdUsuario');
    }

    return retorno;

  }

  async getUltimaAutorizacaoPorIdUsuario(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_autorizacao_recente",
        params.idusuario
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

      this.loadAutorizacoes(retorno.response);

    } catch (error) {
      this.handleError(error, 'getUltimaAutorizacaoPorIdUsuario');
    }

    return retorno;

  }

  //#endregion

  //#region CARTOES

  checkTag(body: any) {

    if (body.tag_tipoacesso != 6/* PLACA */) {
      body.tag_id = this.getOnlyNumbers(body.tag_id)
      // Nao pode porque tem cliente que coloca letras no numero impresso do cartão, EX: BR 1401
      //body.tag_numeroimpresso = this.getOnlyNumbers(body.tag_numeroimpresso)
      // SENHA = 4
      if (body.tag_tipoacesso != '4') {
        body.tag_id = this.removeZerosLeft(body.tag_id)
      }
    }

  }

  async loadCartoes(autorizacoes_json) {

  }

  /**
   * TAG - Cartões, Senhas, TAG
   * @param operation 
   * @param result 
   */

  async createTag(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "tags/";

      this.checkTag(body);

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'createTag');
    }

    return retorno;

  }

  async updateTag(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "tags/" + id;

      this.checkTag(body);

      retorno = await this.http.patch<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'updateTag');
    }

    return retorno;

  }


  async patchTag(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "tags/" + id;

      this.checkTag(body);

      retorno = await this.http.patch<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'patchTag');
    }

    return retorno;

  }

  async removeTag(id: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "tags/" + id;

      await this.http.delete<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'removeTag');
    }

    return retorno;

  }

  async getTagPorID(id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "tags/" + id;

      retorno = await this.http.get<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getTagPorID');
    }

    return retorno;

  }

  async getTagsPor(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      /*
          tag_tipoacesso: 
          TAG = 1,
          CARTAO = 2,
          BIOMETRIA = 3,
          SENHA = 4,
          QRCODE = 5
      */

      var body = [
        "view_tags",
        this.login.idCliente,
        params.idusuario,
        params.fk_idveiculo,
        params.searchQuery,
        params.tipoacesso,
        (!params.status || params.status.length == 2) ? null : params.status[0],
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

      if (retorno && retorno.response) {

        retorno.response.forEach(element => {

          element.img = this.generateUrlImage("tag", element.pk_idtag, true);

        });

      }

    } catch (error) {
      this.handleError(error, 'getViewTags');
    }

    return retorno;

  }

  async getTagPorNumero(tagid: string): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_tag",
        this.login.idCliente,
        tagid // tag_id
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getTagPorNumero');
    }

    return retorno;

  }

  async getTagPorNumeroOuNumeroImpresso(tagid: string, tipoacesso: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_tag_numero_ou_numeroimpresso",
        this.login.idCliente,
        tagid, // tag_id
        tipoacesso
      ]

      const urlAPI = this.urlServerAPI + "view_produtotags";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getTagPorNumeroOuNumeroImpresso');
    }

    return retorno;

  }
  //#endregion

  /**
   * TAG 
   * @param operation 
   * @param result 
   */

  async createProductTag(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "produtotags/";

      this.checkTag(body);

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'createProductTag');
    }

    return retorno;

  }

  async updateProductTag(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "produtotags/" + id;

      //this.checkProductTag(body);

      retorno = await this.http.patch<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'updateProductTag');
    }

    return retorno;

  }


  async patchProductTag(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {


      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "produtotags/" + id;

      //this.checkProductTag(body);

      retorno = await this.http.patch<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'patchProductTag');
    }

    return retorno;

  }

  async patchManyProductTag(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "produtotags/update/many";

      //this.checkProductTag(body);

      retorno = await this.http.put<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'putManyProductTag');
    }

    return retorno;

  }

  async removeProductTag(id: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "produtotags/" + id;

      await this.http.delete<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'removeProductTag');
    }

    return retorno;

  }

  async getProductTagPorID(id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "produtotags/" + id;

      retorno = await this.http.get<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getProductTagPorID');
    }

    return retorno;

  }

  async getProductTagsPor(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      /*
          tag_tipoacesso: 
          TAG = 1,
          CARTAO = 2,
          BIOMETRIA = 3,
          SENHA = 4,
          QRCODE = 5
      */

      var body = [
        "view_produtotags",
        this.login.idCliente,
        params.searchQuery,
        params.fk_idempresa && params.fk_idempresa[0] != '0' ? params.fk_idempresa.toString() : null,
        params.fk_idproduto || 0,
        params.fk_idusuario || 0,
        params.fk_idestoque || 0,
        (!params.status || params.status.length == 2) ? null : params.status[0],
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

      if (retorno && retorno.response) {

        retorno.response.forEach(element => {

          //element.img = this.generateUrlImage("tag", element.pk_idtag, true);

        });

      }

    } catch (error) {
      this.handleError(error, 'getViewTags');
    }

    return retorno;

  }

  async getProductTagPorNumero(pta_id: string): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_produtotags",
        this.login.idCliente,
        pta_id // tag_id
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getTagProdutoPorNumero');
    }

    return retorno;

  }
  //#endregion

  //#region DOCUMENTOS

  checkDocumento(body: any) {

  }


  /**
   * DOCUMENTO
   * @param operation 
   * @param result 
   */

  async createDocumento(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "documentos/";

      this.checkDocumento(body);

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'createDocumento');
    }

    return retorno;

  }

  async updateDocumento(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "documentos/" + id;

      this.checkDocumento(body);

      retorno = await this.http.patch<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'updateDocumento');
    }

    return retorno;

  }


  async patchDocumento(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "documentos/" + id;

      this.checkDocumento(body);

      retorno = await this.http.patch<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'patchDocumento');
    }

    return retorno;

  }

  async removeDocumento(id: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "documentos/" + id;

      await this.http.delete<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'removeDocumento');
    }

    return retorno;

  }

  async getDocumentoPorID(id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "documentos/" + id;

      retorno = await this.http.get<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getDocumentoPorID');
    }

    return retorno;

  }

  async getDocumentosPor(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_documentos",
        this.login.idCliente,
        params.idusuario,
        (!params.status || params.status.length == 2) ? null : params.status[0],
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

      if (retorno && retorno.response) {

        retorno.response.forEach(element => {

          element.img = this.generateUrlImage("documento", element.pk_iddocumento);

        });

      }

    } catch (error) {
      this.handleError(error, 'getDocumentosPor');
    }

    return retorno;

  }

  //#endregion


  //#region OBJETOS

  checkObjeto(body: any) {

  }


  /**
   * DOCUMENTO
   * @param operation 
   * @param result 
   */

  async createObjeto(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "objetos/";

      this.checkObjeto(body);

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'createObjeto');
    }

    return retorno;

  }

  async updateObjeto(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "objetos/" + id;

      this.checkObjeto(body);

      retorno = await this.http.patch<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'updateObjeto');
    }

    return retorno;

  }


  async patchObjeto(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "objetos/" + id;

      this.checkObjeto(body);

      retorno = await this.http.patch<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'patchObjeto');
    }

    return retorno;

  }

  async removeObjeto(id: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "objetos/" + id;

      await this.http.delete<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'removeObjeto');
    }

    return retorno;

  }

  async getObjetoPorID(id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "objetos/" + id;

      retorno = await this.http.get<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getObjetoPorID');
    }

    return retorno;

  }

  async getObjetosPor(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_objetos",
        this.login.idCliente,
        params.idusuario,
        params.searchQuery,
        params.empresa && params.empresa[0] != '0' ? params.empresa.toString() : null, //separado por virgula .toString(); // array.toString(); // '1,2,3'
        params.setor, // id grupo
        (!params.status || params.status.length == 2) ? null : params.status[0],
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

      if (retorno && retorno.response) {

        retorno.response.forEach(element => {

          element.img = this.generateUrlImage("objeto", element.pk_idobjeto);

        });

      }

    } catch (error) {
      this.handleError(error, 'getObjetosPor');
    }

    return retorno;

  }

  //#endregion

  //#region ANIMAIS

  checkAnimal(body: any) {

  }


  /**
   * DOCUMENTO
   * @param operation 
   * @param result 
   */

  async createAnimal(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "animais/";

      this.checkAnimal(body);

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'createAnimal');
    }

    return retorno;

  }

  async updateAnimal(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "animais/" + id;

      this.checkAnimal(body);

      retorno = await this.http.patch<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'updateAnimal');
    }

    return retorno;

  }


  async patchAnimal(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "animais/" + id;

      this.checkAnimal(body);

      retorno = await this.http.patch<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'patchAnimal');
    }

    return retorno;

  }

  async removeAnimal(id: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "animais/" + id;

      await this.http.delete<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'removeAnimal');
    }

    return retorno;

  }

  async getAnimalPorID(id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "animais/" + id;

      retorno = await this.http.get<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getAnimalPorID');
    }

    return retorno;

  }

  async getAnimaisPor(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_animais",
        this.login.idCliente,
        params.idusuario,
        (!params.status || params.status.length == 2) ? null : params.status[0],
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

      if (retorno && retorno.response) {

        retorno.response.forEach(element => {

          element.img = this.generateUrlImage("animal", element.pk_idanimal);

        });

      }

    } catch (error) {
      this.handleError(error, 'getAnimaisPor');
    }

    return retorno;

  }

  //#endregion

  //#region BIOMETRIAS

  checkBiometria(body: any) {

  }


  /**
   * TAG - Cartões, Senhas, TAG
   * @param operation 
   * @param result 
   */

  async createBiometria(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "biometrias";

      this.checkBiometria(body);

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'createBiometria');
    }

    return retorno;

  }

  async updateBiometria(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "biometrias/" + id;

      this.checkBiometria(body);

      retorno = await this.http.patch<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'updateBiometria');
    }

    return retorno;

  }

  async removeBiometria(id: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "biometrias/" + id;

      await this.http.delete<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'removeBiometria');
    }

    return retorno;

  }

  async getBiometriaPorID(id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "biometrias/" + id;

      retorno = await this.http.get<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getBiometriaPorID');
    }

    return retorno;

  }

  async getBiometriasPorIDUsuario(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_biometrias_por_id_usuario",
        this.login.idCliente,
        params.idusuario,
        (!params.status || params.status.length == 2) ? null : params.status[0],
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getBiometriasPorIDUsuario');
    }

    return retorno;

  }
  //#endregion

  //#region CORES
  async createCor(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "cores/";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'createCor');
    }

    return retorno;

  }

  async getCores(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_cores",
        this.login.idCliente,
        params.searchQuery,
        100, //this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getCores');
    }

    return retorno;

  }
  //#endregion

  //#region EMPRESA

  checkEmpresa(body: any) {

    body.emp_qtdandares = this.parseToInt(body.emp_qtdandares)
    body.emp_qtdaptporandar = this.parseToInt(body.emp_qtdaptporandar)
    body.emp_nome = this.removeSpacesAndAccent(body.emp_nome)

  }


  /**
   * TAG - Cartões, Senhas, TAG
   * @param operation 
   * @param result 
   */

  async createEmpresa(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "empresas/";

      this.checkEmpresa(body);

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'createEmpresa');
    }

    return retorno;

  }

  async updateEmpresa(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "empresas/" + id;

      this.checkEmpresa(body);

      retorno = await this.http.patch<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'updateEmpresa');
    }

    return retorno;

  }

  async patchEmpresa(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "empresas/" + id;

      retorno = await this.http.patch<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'patchEmpresa');
    }

    return retorno;

  }


  async removeEmpresa(id: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "empresas/" + id;

      await this.http.delete<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'removeEmpresa');
    }

    return retorno;

  }

  async getEmpresaPorID(id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "empresas/" + id;

      retorno = await this.http.get<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getEmpresaPorID');
    }

    return retorno;

  }

  async getEmpresas(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_empresas",
        this.login.idCliente,
        params.searchQuery,
        this.login.conta.pk_idconta,
        (!params.status || params.status.length == 2) ? null : params.status[0],
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getEmpresas');
    }

    return retorno;

  }
  //#endregion

  //#region SETOR
  checkSetor(body: any) {

    body.set_nome = this.removeSpacesAndAccent(body.set_nome)

  }

  async createSetor(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "setores/";

      this.checkSetor(body);

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'createSetor');
    }

    return retorno;

  }

  async updateSetor(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "setores/" + id;

      this.checkSetor(body);

      retorno = await this.http.patch<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'updateSetor');
    }

    return retorno;

  }

  async patchSetor(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "setores/" + id;

      retorno = await this.http.patch<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'patchSetor');
    }

    return retorno;

  }

  async removeSetor(id: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "setores/" + id;

      await this.http.delete<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'removeSetor');
    }

    return retorno;

  }

  async getSetorPorID(id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "setores/" + id;

      retorno = await this.http.get<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getSetorPorID');
    }

    return retorno;

  }

  async getSetores(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_setores",
        this.login.idCliente,
        params.searchQuery,
        this.login.conta.pk_idconta,
        params.empresa,
        (!params.status || params.status.length == 2) ? null : params.status[0],
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getSetores');
    }

    return retorno;

  }

  async criarUnidades(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "func_criar_setores",
        this.login.idCliente,
        params.emp_qtdandares,
        params.emp_qtdaptporandar,
        params.pk_idempresa
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'criarUnidades');
    }

    return retorno;

  }
  //#endregion

  //#region VINCULO

  //#endregion

  //#region PODERES
  async getPoderes(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_poderes",
        this.login.idCliente,
        params.searchQuery,
        this.login.conta.pk_idconta,
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getPoderes');
    }

    return retorno;

  }
  //#endregion  

  //#region TELEFONE

  checkTelefone(body: any) {

  }


  /**
   * TELEFONE - Cartões, Senhas, TELEFONE
   * @param operation 
   * @param result 
   */

  async createTelefone(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {
      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "telefones/";

      this.checkTelefone(body);

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'createTelefone');
    }

    return retorno;

  }

  async updateTelefone(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "telefones/" + body.pk_idtelefone;

      this.checkTelefone(body);

      retorno = await this.http.put<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'updateTelefone');
    }

    return retorno;

  }

  async removeTelefone(id: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "telefones/" + id;

      await this.http.delete<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'removeTelefone');
    }

    return retorno;

  }

  async getTelefonePorID(id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "telefones/" + id;

      retorno = await this.http.get<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getTelefonePorID');
    }

    return retorno;

  }

  async getTelefonesPorIDUsuario(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_telefones",
        this.login.idCliente,
        params.idusuario,
        params.searchQuery,
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getTelefonesPorIDUsuario');
    }

    return retorno;

  }

  //#endregion

  //#region VEICULO

  checkVeiculo(body: any) {

    body.vei_nome = this.removeSpacesAndAccent(body.vei_nome)
    body.vei_placa = this.getOnlyNumbersAndLetters(body.vei_placa)

  }


  /**
   * VEICULO
   * @param operation 
   * @param result 
   */

  async createVeiculo(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "veiculos/";

      this.checkVeiculo(body);

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'createVeiculo');
    }

    return retorno;

  }

  async updateVeiculo(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "veiculos/" + body.pk_idveiculo;

      this.checkVeiculo(body);

      retorno = await this.http.put<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'updateVeiculo');
    }

    return retorno;

  }

  async patchVeiculo(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "veiculos/" + id;

      retorno = await this.http.patch<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'patchVeiculo');
    }

    return retorno;

  }

  async removeVeiculo(id: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "veiculos/" + id;

      await this.http.delete<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'removeVeiculo');
    }

    return retorno;

  }

  async getVeiculoPorID(id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "veiculos/" + id;

      retorno = await this.http.get<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getVeiculoPorID');
    }

    return retorno;

  }

  async getVeiculosPorIDUsuario(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_veiculos_por_id_usuario",
        this.login.idCliente,
        params.idusuario,
        params.searchQuery,
        (!params.status || params.status.length == 2) ? null : params.status[0],
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getVeiculosPorIDUsuario');
    }

    return retorno;

  }

  async getVeiculoPorPlaca(placa: string): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_veiculo_por_placa",
        this.login.idCliente,
        placa
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();


    } catch (error) {
      this.handleError(error, 'getVeiculoPorPlaca');
    }

    return retorno;

  }


  async getVeiculosPor(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_veiculos",
        this.login.idCliente,
        params.searchQuery,
        params.empresa && params.empresa[0] != '0' ? params.empresa.toString() : null, //separado por virgula .toString(); // array.toString(); // '1,2,3'
        params.setor, // id grupo
        params.vinculo,
        params.tiposPessoas && params.tiposPessoas[0] > 0 ? params.tiposPessoas.toString() : null, //separado por virgula .toString(); // array.toString(); // '1,2,3'    
        params.tipoVeiculo.length == 0 ? null : params.tipoVeiculo, // Moto ou Carro
        params.semTag.length == 0 ? null : params.semTag, // Com ou sem TAG
        (!params.status || params.status.length == 2) ? null : params.status[0],
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy.toString(),
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getVeiculosPor');
    }

    return retorno;

  }

  async getVeiculoPorPlacaAPI(placa: string): Promise<any> {

    var retorno = null;

    try {
      // https://github.com/100n0m3/API-Carros
      // https://apiplacas.com.br/doc.php
      retorno = await this.http.get(`https://apicarros.com/v2/consultas/${placa}/d21b9974dd05d8f2a51ae88650e70d04`).toPromise();

      // upperCase
      this.toUpperCase(retorno);

    } catch (error) {
      this.handleError(error, 'getVeiculoPorPlacaAPI');
    }

    return retorno;

  }

  //#endregion

  //#region OPERADORA
  checkOperadora(body: any) {

  }

  /**
   * Operadoras de Telefonia
   * @param operation 
   * @param result 
   */

  async createOperadora(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "operadoras/";

      this.checkOperadora(body);

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'createOperadora');
    }

    return retorno;

  }

  async updateOperadora(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "operadoras/" + body.pk_idoperadora;

      this.checkOperadora(body);

      retorno = await this.http.put<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'updateOperadora');
    }

    return retorno;

  }

  async patchOperadora(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "operadoras/" + body.pk_idoperadora;

      retorno = await this.http.patch<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'patchOperadora');
    }

    return retorno;

  }

  async removeOperadora(id: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "operadoras/" + id;

      await this.http.delete<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'removeOperadora');
    }

    return retorno;

  }

  async getOperadoraPorID(id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "operadoras/" + id;

      retorno = await this.http.get<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

      let data = retorno.response[0];

    } catch (error) {
      this.handleError(error, 'getOperadoraPorID');
    }

    return retorno;

  }

  async getOperadoras(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_operadoras",
        this.login.idCliente,
        params.searchQuery,
        (!params.status || params.status.length == 2) ? null : params.status[0],
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getOperadoras');
    }

    return retorno;

  }
  //#endregion

  //#region TIPO_TELEFONES
  async getTipoTelefones(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_tipotelefones",
        this.login.idCliente,
        params.searchQuery,
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getTipoTelefones');
    }

    return retorno;

  }
  //#endregion

  //#region TIPO_COMANDOS

  checkTipocomando(body: any) {

    body.pk_idtipocomando = this.getOnlyNumbers(body.pk_idtipocomando);

  }

  /**
   * Tipocomandos de Usuário
   * @param operation 
   * @param result 
   */

  async createTipocomando(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "tipocomandos/";

      this.checkTipocomando(body);

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'createTipocomando');
    }

    return retorno;

  }

  async updateTipocomando(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "tipocomandos/" + body.pk_idtipocomando;

      this.checkTipocomando(body);

      retorno = await this.http.put<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'updateTipocomando');
    }

    return retorno;

  }

  async patchTipocomando(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "tipocomandos/" + body.pk_idtipocomando;

      retorno = await this.http.patch<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'patchTipocomando');
    }

    return retorno;

  }

  async removeTipocomando(id: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "tipocomandos/" + id;

      await this.http.delete<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'removeTipocomando');
    }

    return retorno;

  }

  async getTipocomandoPorID(id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "tipocomandos/" + id;

      retorno = await this.http.get<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

      let data = retorno.response[0];

    } catch (error) {
      this.handleError(error, 'getTipocomandoPorID');
    }

    return retorno;

  }

  async getTipocomandos(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_tipocomandos",
        this.login.idCliente,
        params.searchQuery,
        (!params.status || params.status.length == 2) ? null : params.status[0],
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getTipocomandos');
    }

    return retorno;

  }

  //#endregion

  //#region HORARIOS

  checkHorario(body: any) {

  }

  /**
   * Horarios de Usuário
   * @param operation 
   * @param result 
   */

  async createHorario(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "horarios/";

      this.checkHorario(body);

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'createHorario');
    }

    return retorno;

  }

  async updateHorario(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "horarios/" + body.pk_idhorario;

      this.checkHorario(body);

      retorno = await this.http.put<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'updateHorario');
    }

    return retorno;

  }

  async patchHorario(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "horarios/" + body.pk_idhorario;

      retorno = await this.http.patch<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'patchHorario');
    }

    return retorno;

  }

  async removeHorario(id: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "horarios/" + id;

      await this.http.delete<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'removeHorario');
    }

    return retorno;

  }

  async getHorarioPorID(id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "horarios/" + id;

      retorno = await this.http.get<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

      let data = retorno.response[0];

    } catch (error) {
      this.handleError(error, 'getHorarioPorID');
    }

    return retorno;

  }

  async getHorarios(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_horarios",
        this.login.idCliente,
        params.searchQuery,
        !params.status || (!params.status || params.status.length == 2) ? null : params.status[0],
        this.login.idConta,
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getHorarios');
    }

    return retorno;

  }

  //#endregion

  //#region HORARIO_ITENS

  checkHorarioItens(body: any) {



  }

  /**
   * HorarioItenss de Usuário
   * @param operation 
   * @param result 
   */

  async createHorarioItens(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "horarioitens/";

      this.checkHorarioItens(body);

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'createHorarioItens');
    }

    return retorno;

  }

  async updateHorarioItens(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "horarioitens/" + id;

      this.checkHorarioItens(body);

      retorno = await this.http.put<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'updateHorarioItens');
    }

    return retorno;

  }

  async patchHorarioItens(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "horarioitens/" + id;

      retorno = await this.http.patch<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'patchHorarioItens');
    }

    return retorno;

  }

  async removeHorarioItens(id: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "horarioitens/" + id;

      await this.http.delete<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'removeHorarioItens');
    }

    return retorno;

  }

  async getHorarioItensPorID(id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "horarioitens/" + id;

      retorno = await this.http.get<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

      let data = retorno.response[0];

    } catch (error) {
      this.handleError(error, 'getHorarioItensPorID');
    }

    return retorno;

  }

  async getHorarioItens(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_horarioitens",
        this.login.idCliente,
        params.searchQuery,
        (!params.status || params.status.length == 2) ? null : params.status[0],
        this.login.idConta,
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getHorarioItenss');
    }

    return retorno;

  }

  async getHorarioItensPorIDHorario(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_horarioitens_por_id_horario",
        this.login.idCliente,
        params.idhorario,
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getHorarioItensPorIDHorario');
    }

    return retorno;

  }

  //#endregion

  //#region DIA_SEMANA
  async getDiasemanas(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_diasemanas",
        this.login.idCliente,
        params.searchQuery,
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getDiasemanas');
    }

    return retorno;

  }

  //#endregion

  //#region LOCAL_ACESSOS

  checkLocalacessos(body: any) {

    if (body.fk_idempresa != null) {
      body.fk_idempresa = body.fk_idempresa > 0 ? body.fk_idempresa : null;
    }
  }

  /**
   * Localacessoss de Usuário
   * @param operation 
   * @param result 
   */

  async createLocalacesso(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "localacessos/";

      this.checkLocalacessos(body);

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'createLocalacessos');
    }

    return retorno;

  }

  async updateLocalacesso(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "localacessos/" + id;

      this.checkLocalacessos(body);

      retorno = await this.http.put<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'updateLocalacessos');
    }

    return retorno;

  }

  async patchLocalacesso(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "localacessos/" + id;

      this.checkLocalacessos(body);

      retorno = await this.http.patch<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'patchLocalacessos');
    }

    return retorno;

  }

  async removeLocalacesso(id: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "localacessos/" + id;

      await this.http.delete<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'removeLocalacessos');
    }

    return retorno;

  }

  async getLocalacessoPorID(id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "localacessos/" + id;

      retorno = await this.http.get<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getLocalacessosPorID');
    }

    return retorno;

  }

  async getLocalAcessos(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_localacessos",
        this.login.idCliente,
        params.searchQuery,
        (!params.status || params.status.length == 2) ? null : params.status[0],
        this.login.conta.pk_idconta,
        params.locaisdeacesso,
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getLocalAcessos');
    }

    return retorno;

  }


  //#endregion

  //#region ESTOQUES

  async getEstoques(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_estoques",
        this.login.idCliente,
        params.searchQuery, // Pesquisa por local
        params.fk_idempresa, // ID da Empresa
        (!params.status || params.status.length == 2) ? null : params.status[0],
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getEstoques');
    }

    return retorno;

  }
  //#endregion

  //#region MOTIVOS

  checkMotivos(body: any) {

  }

  /**
   * Motivoss de Usuário
   * @param operation 
   * @param result 
   */

  async createMotivo(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "motivos/";

      this.checkMotivos(body);

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'createMotivos');
    }

    return retorno;

  }

  async updateMotivo(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "motivos/" + id;

      this.checkMotivos(body);

      retorno = await this.http.put<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'updateMotivos');
    }

    return retorno;

  }

  async patchMotivo(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "motivos/" + id;

      retorno = await this.http.patch<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'patchMotivos');
    }

    return retorno;

  }

  async removeMotivo(id: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "motivos/" + id;

      await this.http.delete<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'removeMotivos');
    }

    return retorno;

  }

  async getMotivoPorID(id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "motivos/" + id;

      retorno = await this.http.get<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getMotivosPorID');
    }

    return retorno;

  }

  async getMotivos(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_motivos",
        this.login.idCliente,
        params.searchQuery,
        params.tipo.length == 2 ? null : params.tipo[0],
        (!params.status || params.status.length == 2) ? null : params.status[0],
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getMotivos');
    }

    return retorno;

  }


  //#endregion


  //#region BLOQUEIOS

  checkBloqueios(body: any) {

  }

  /**
   * Bloqueioss de Usuário
   * @param operation 
   * @param result 
   */

  async createBloqueio(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "bloqueios/";

      this.checkBloqueios(body);

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'createBloqueios');
    }

    return retorno;

  }

  async updateBloqueio(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "bloqueios/" + id;

      this.checkBloqueios(body);

      retorno = await this.http.put<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'updateBloqueios');
    }

    return retorno;

  }

  async patchBloqueio(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "bloqueios/" + id;

      retorno = await this.http.patch<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'patchBloqueios');
    }

    return retorno;

  }

  async removeBloqueio(id: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "bloqueios/" + id;

      await this.http.delete<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'removeBloqueios');
    }

    return retorno;

  }

  async getBloqueioPorID(id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "bloqueios/" + id;

      retorno = await this.http.get<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getBloqueiosPorID');
    }

    return retorno;

  }

  async getBloqueiosPorIDUsuario(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_bloqueios",
        this.login.idCliente,
        params.idusuario,
        (!params.status || params.status.length == 2) ? null : params.status[0],
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getBloqueiosPorIDUsuario');
    }

    return retorno;

  }

  //#endregion


  //#region PERFIL_DE_ACESSOS

  checkPerfisdeacessos(body: any) {

  }

  /**
   * Perfisdeacessos
   * @param operation 
   * @param result 
   */

  async createPerfisdeacesso(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "perfisdeacessos/";

      this.checkPerfisdeacessos(body);

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'createPerfisdeacessos');
    }

    return retorno;

  }

  async updatePerfisdeacesso(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "perfisdeacessos/" + id;

      this.checkPerfisdeacessos(body);

      retorno = await this.http.put<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'updatePerfisdeacessos');
    }

    return retorno;

  }

  async patchPerfisdeacesso(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "perfisdeacessos/" + id;

      retorno = await this.http.patch<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'patchPerfisdeacessos');
    }

    return retorno;

  }

  async removePerfisdeacesso(id: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "perfisdeacessos/" + id;

      await this.http.delete<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'removePerfisdeacessos');
    }

    return retorno;

  }

  async getPerfisdeacessoPorID(id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "perfisdeacessos/" + id;

      retorno = await this.http.get<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getPerfisdeacessosPorID');
    }

    return retorno;

  }

  async getPerfisdeacessos(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_perfisdeacessos",
        this.login.idCliente,
        params.searchQuery,
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getPerfisdeacessos');
    }

    return retorno;

  }


  //#endregion

  //#region VINCULOS

  checkVinculos(body: any) {



  }

  /**
   * Vinculoss de Usuário
   * @param operation 
   * @param result 
   */

  async createVinculo(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "vinculos/";

      this.checkVinculos(body);

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'createVinculo');
    }

    return retorno;

  }

  async updateVinculo(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "vinculos/" + id;

      this.checkVinculos(body);

      retorno = await this.http.put<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'updateVinculo');
    }

    return retorno;

  }

  async patchVinculo(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "vinculos/" + id;

      retorno = await this.http.patch<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'patchVinculo');
    }

    return retorno;

  }

  async removeVinculo(id: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "vinculos/" + id;

      await this.http.delete<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'removeVinculo');
    }

    return retorno;

  }

  async getVinculoPorID(id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "vinculos/" + id;

      retorno = await this.http.get<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

      let data = retorno.response[0];

    } catch (error) {
      this.handleError(error, 'getVinculoPorID');
    }

    return retorno;

  }

  async getVinculos(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_vinculos",
        this.login.idCliente,
        params.searchQuery,
        this.login.conta.pk_idconta,
        params.perfil && params.perfil[0] > 0 ? params.perfil.toString() : null, //separado por virgula .toString(); // array.toString(); // '1,2,3'    
        200, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getVinculos');
    }

    return retorno;

  }

  async getVinculosPorIDPerfilDeAcesso(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_vinculos_por_id_perfil",
        this.login.idCliente,
        params.idperfisdeacesso,
        params.searchQuery,
        params.status,
        200, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getVinculosPorIDPerfilDeAcesso');
    }

    return retorno;

  }

  //#endregion

  //#region VINCULOS

  checkPerfilLocalAcessos(body: any) {

    if (body.pla_locaisdeacesso) {
      body.pla_locaisdeacesso = body.pla_locaisdeacesso.toString(); // array.toString(); // '1,2,3'
    }
  }

  async loadPerfilLocalAcessos(data_json) {

    if (data_json) {
      data_json.forEach(o => {

        try {

          // convert to array of int        
          o.pla_locaisdeacesso = o.pla_locaisdeacesso.split(',').map(function (item) {
            return parseInt(item, 10);
          });

          if (o.locaisdeacesso_json) {
            o.locaisdeacesso_json = this.stringToJSON(o.locaisdeacesso_json);
          }

        } catch (error) {
          console.log('loadPerfilLocalAcessos: ' + error);
        }

      });
    }
  }

  /**
   * PerfilLocalAcessoss de Usuário
   * @param operation 
   * @param result 
   */

  async createPerfillocalacesso(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "perfillocalacessos/";

      this.checkPerfilLocalAcessos(body);

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'createPerfillocalacesso');
    }

    return retorno;

  }

  async updatePerfillocalacesso(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "perfillocalacessos/" + id;

      this.checkPerfilLocalAcessos(body);

      retorno = await this.http.put<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'updatePerfillocalacesso');
    }

    return retorno;

  }

  async patchPerfillocalacesso(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "perfillocalacessos/" + id;

      this.checkPerfilLocalAcessos(body);

      retorno = await this.http.patch<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'patchPerfillocalacesso');
    }

    return retorno;

  }

  async removePerfillocalacesso(id: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "perfillocalacessos/" + id;

      await this.http.delete<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'removePerfillocalacesso');
    }

    return retorno;

  }

  async getPerfillocalacessoPorID(id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "perfillocalacessos/" + id;

      retorno = await this.http.get<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

      let data = retorno.response[0];

    } catch (error) {
      this.handleError(error, 'getPerfillocalacessoPorID');
    }

    return retorno;

  }

  async getPerfilLocalAcessos(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_perfillocalacessos",
        this.login.idCliente,
        params.searchQuery,
        this.login.conta.pk_idconta,
        params.perfil && params.perfil[0] > 0 ? params.perfil.toString() : null, //separado por virgula .toString(); // array.toString(); // '1,2,3'    
        params.idempresa,
        params.rowLimit ? params.rowLimit : this.getRowLimit, //max_limit INT,
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

      this.loadPerfilLocalAcessos(retorno.response);

    } catch (error) {
      this.handleError(error, 'getPerfilLocalAcessos');
    }

    return retorno;

  }

  async getPerfilLocalAcessosPorIDPerfilDeAcesso(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_perfillocalacessos_por_id_perfil",
        this.login.idCliente,
        params.idperfisdeacesso,
        params.searchQuery,
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

      this.loadPerfilLocalAcessos(retorno.response);

    } catch (error) {
      this.handleError(error, 'getPerfilLocalAcessosPorIDPerfilDeAcesso');
    }

    return retorno;

  }

  //#endregion

  //#region GRUPOS

  checkGrupos(body: any) {



  }

  /**
   * Grupos de Usuário
   * @param operation 
   * @param result 
   */

  async createGrupo(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "grupos/";

      this.checkGrupos(body);

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'createGrupo');
    }

    return retorno;

  }

  async updateGrupo(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "grupos/" + id;

      this.checkGrupos(body);

      retorno = await this.http.put<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'updateGrupo');
    }

    return retorno;

  }

  async patchGrupo(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "grupos/" + id;

      retorno = await this.http.patch<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'patchGrupo');
    }

    return retorno;

  }

  async removeGrupo(id: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "grupos/" + id;

      await this.http.delete<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'removeGrupo');
    }

    return retorno;

  }

  async getGrupoPorID(id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "grupos/" + id;

      retorno = await this.http.get<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

      let data = retorno.response[0];

    } catch (error) {
      this.handleError(error, 'getGruposPorID');
    }

    return retorno;

  }

  async getGrupos(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_grupos",
        this.login.idCliente,
        params.searchQuery,
        !params.status || (!params.status || params.status.length == 2) ? null : params.status[0],
        this.login.conta.pk_idconta,
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getGrupos');
    }

    return retorno;

  }


  //#endregion

  //#region CONFIGURACOES

  async hasServico() {

    var user = await this.getUser();

    return user?.configuracao_atual &&
      user.configuracao_atual.visitante?.mostrar_servicos ||
      user.configuracao_atual.morador?.mostrar_servicos ||
      user.configuracao_atual.funcionario?.mostrar_servicos ||
      user.configuracao_atual.aluno?.mostrar_servicos
  }

  checkConfiguracoes(body: any) {

  }

  async loadConfiguracoes(body: any) {

    body.forEach(o => {
      try {

        o.csi_configuracao = this.stringToJSON(o.csi_configuracao);

      } catch (error) {
        console.log(error);
      }

    });

  }

  /**
   * Configuracoes de Usuário
   * @param operation 
   * @param result 
   */

  async createConfiguracoes(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "configuracaosistemas/";

      this.checkConfiguracoes(body);

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'createConfiguracoes');
    }

    return retorno;

  }

  async updateConfiguracoes(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "configuracaosistemas/" + id;

      this.checkConfiguracoes(body);

      retorno = await this.http.put<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'updateConfiguracoes');
    }

    return retorno;

  }

  async patchConfiguracoes(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "configuracaosistemas/" + id;

      retorno = await this.http.patch<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'patchConfiguracoes');
    }

    return retorno;

  }

  async removeConfiguracoes(id: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "configuracaosistemas/" + id;

      await this.http.delete<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'removeConfiguracoes');
    }

    return retorno;

  }

  async getConfiguracoesPorID(id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "configuracaosistemas/" + id;

      retorno = await this.http.get<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

      this.loadConfiguracoes(retorno.response);

    } catch (error) {
      this.handleError(error, 'getConfiguracoesPorID');
    }

    return retorno;

  }

  async getConfiguracaoPorIDCliente(params: any = null): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_configuracoes",
        this.login.idCliente
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

      this.loadConfiguracoes(retorno.response);

    } catch (error) {
      this.handleError(error, 'getConfiguracaoPorIDCliente');
    }

    return retorno;

  }


  //#endregion


  //#region GRUPO_PERMISSAO

  checkGrupoPermissoes(body: any) {



  }

  loadGrupoPermissoes(body: any) {

    let retorno = null;

    if (body) {

      let secoes = [];
      let secao_atual = null;

      body.forEach(o => {

        try {

          // Organizando os dicionarios dentro das secoes
          // Exemplo de retorno do SQL: 
          // pk_iddicionario, dic_nome,           pk_idsecao, sec_nome,   grupos_permissoes_json
          // 2	            EMPRESA VISITANTE	3	        Cadastros	[{"pk_idgrupo_permissao":1019,"gpe_acesso":"R"}]

          if (secao_atual == null || secao_atual.pk_idsecao != o.pk_idsecao) {

            secao_atual = {
              pk_idsecao: o.pk_idsecao,
              sec_nome: o.sec_nome,
              dicionarios: []
            };

            // Adiciona mais uma secao a lista
            secoes.push(secao_atual);
          }

          var grupos_permissoes_json = {
            pk_idgrupo_permissao: null,
            gpe_acesso: null,
            marcartodos: false
          };

          if (o.grupos_permissoes_json) {

            grupos_permissoes_json = this.stringToJSON(o.grupos_permissoes_json);

            grupos_permissoes_json = grupos_permissoes_json[0];

            if (grupos_permissoes_json.gpe_acesso) {
              grupos_permissoes_json.gpe_acesso = grupos_permissoes_json.gpe_acesso.split("");
              grupos_permissoes_json.marcartodos = grupos_permissoes_json.gpe_acesso.length == 4;
            }

          }

          // Adicionando cada dicionario a sua secao
          secao_atual.dicionarios.push({
            pk_iddicionario: o.pk_iddicionario,
            dic_nome: o.dic_nome,
            permissao: grupos_permissoes_json
          });


        } catch (error) {
          console.log('loadGrupoPermissoes: ' + error);
        }

      });

      retorno = secoes;

    }

    return retorno;
  }

  /**
   * GrupoPermissoess de Usuário
   * @param operation 
   * @param result 
   */

  async createGrupoPermissoes(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "grupopermissoes/";

      this.checkGrupoPermissoes(body);

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'createGrupoPermissoes');
    }

    return retorno;

  }

  async updateGrupoPermissoes(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "grupopermissoes/" + id;

      this.checkGrupoPermissoes(body);

      retorno = await this.http.put<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'updateGrupoPermissoes');
    }

    return retorno;

  }

  async patchGrupoPermissoes(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "grupopermissoes/" + id;

      retorno = await this.http.patch<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'patchGrupoPermissoes');
    }

    return retorno;

  }

  async removeGrupoPermissoes(id: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "grupopermissoes/" + id;

      await this.http.delete<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'removeGrupoPermissoes');
    }

    return retorno;

  }

  async getGrupoPermissoesPorID(id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "grupopermissoes/" + id;

      retorno = await this.http.get<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

      let data = retorno.response[0];

    } catch (error) {
      this.handleError(error, 'getGrupoPermissoesPorID');
    }

    return retorno;

  }

  async getGrupoPermissoesPorIDGrupo(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_grupodecontas",
        this.login?.idCliente,
        params.idgrupo
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

      retorno.response = this.loadGrupoPermissoes(retorno.response);

    } catch (error) {
      this.handleError(error, 'getGrupoPermissoesPorIDGrupo');
    }

    return retorno;

  }

  //#endregion

  //#region DISPOSITIVO

  checkDispositivos(body: any) {

    if (body.dis_locais) {
      body.dis_locais = body.dis_locais.toString(); // array.toString(); // '1,2,3'
    }

    if (body.dis_modofuncionamento) {
      body.dis_modofuncionamento = body.dis_modofuncionamento.toString(); // array.toString(); // '1,2,3'
    }

  }

  async loadDispositivo(body: any) {

    body.forEach(o => {
      try {

        if (o.dis_regraporlocal != null) {
          // dropdown = sim ou não só funciona como string. Ex.: "true", "false"
          o.dis_regraporlocal = o.dis_regraporlocal.toString()
        }

        if (o.dis_configuracoes) {
          o.dis_configuracoes = this.stringToJSON(o.dis_configuracoes);
        }

        if (o.dis_locais) {
          // convert to array of int        
          o.dis_locais = o.dis_locais.split(',').map(function (item) {
            return parseInt(item, 10);
          });

          o.locaisdeacesso_json = this.stringToJSON(o.locaisdeacesso_json);
        }

        if (o.dis_modofuncionamento) {
          // convert to array of int        
          o.dis_modofuncionamento = o.dis_modofuncionamento.split(',').map(function (item) {
            return parseInt(item, 10);
          });

        }

        if (o.leitores_json) {
          o.leitores_json = this.stringToJSON(o.leitores_json);

          o.leitores_json.forEach(l => {

            try {

              l.dis_configuracoes = this.stringToJSON(l.dis_configuracoes);

              l.dis_sentido = l.dis_configuracoes.sentido || l.dis_sentido;

            } catch (error) {
              console.log(error);
            }

          });
        }

      } catch (error) {
        console.log(error);
      }

    });

  }

  /**
   * Dispositivos
   * @param operation 
   * @param result 
   */

  async createDispositivo(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "dispositivos/";

      this.checkDispositivos(body);

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'createDispositivos');
    }

    return retorno;

  }

  async updateDispositivo(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "dispositivos/" + id;

      this.checkDispositivos(body);

      retorno = await this.http.put<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'updateDispositivos');
    }

    return retorno;

  }

  async patchDispositivo(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "dispositivos/" + id;

      this.checkDispositivos(body);

      retorno = await this.http.patch<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'patchDispositivos');
    }

    return retorno;

  }

  async removeDispositivo(id: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "dispositivos/" + id;

      await this.http.delete<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'removeDispositivos');
    }

    return retorno;

  }

  async getDispositivoPorID(id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_dispositivo_por_id",
        this.login.idCliente,
        id
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

      this.loadDispositivo(retorno.response);

    } catch (error) {
      this.handleError(error, 'getDispositivosPorID');
    }

    return retorno;

  }

  async getDispositivos(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_dispositivos_list",
        this.login.idCliente,
        params.searchQuery,
        params.idmodelo, // id empresa
        params.locais ? params.locais.toString() : null, // locais de acesso separado por virgula .toString(); // array.toString(); // '1,2,3'    
        !params.status_online || params.status_online.length == 2 ? null : params.status_online[0], // ON-line / OFF-line
        !params.status || (!params.status || params.status.length == 2) ? null : params.status[0],
        this.login.conta.pk_idconta,
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

      this.loadDispositivo(retorno.response);

    } catch (error) {
      this.handleError(error, 'getDispositivos');
    }

    return retorno;

  }

  async getLeitoresPorIDDispositivo(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_dispositivo_leitores",
        this.login.idCliente,
        params.iddispositivo
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();


      this.loadDispositivo(retorno.response);

    } catch (error) {
      this.handleError(error, 'getDispositivos');
    }

    return retorno;

  }

  filteredDispositivosStatusObservable = new BehaviorSubject(null);

  async getDispositivosStatus(params: any = null): Promise<ApiResponse> {

    var retorno = null;

    let is404: boolean = false

    if (!this.login || this.login.sessionExpired || !this.login.idCliente) {
      setTimeout(() => {
        this.getDispositivosStatus()
      }, 5000)
      return null
    }

    try {

      let cache = await this.getStorageLocal('cache_status_dispositivos');

      const headers = await this.getHeaders();

      var body = [
        "view_dispositivos",
        this.login.idCliente,
        this.login.conta.con_locais ? this.login.conta.con_locais.toString() : null, // locais de acesso separado por virgula .toString(); // array.toString(); // '1,2,3'    
        0, // iddispositivo
        params ? params.searchQuery : null,
        9999, //this.getRowLimit, //max_limit INT, 
        params ? params.offset || 0 : 0
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

      this.loadDispositivo(retorno.response);

      // Armazenando em cache o status dos dispositivos
      // Para que se evite o uso intenso de chamada ao backend
      // Pois quando tem muitas guias abertas todas chamavam o backend
      // Fazendo com que o banco fique lento
      this.setStorageLocal('cache_status_dispositivos', retorno);

      this.filteredDispositivosStatusObservable.next(retorno);

    } catch (error) {
      is404 = error && error.status == 404;
      this.handleError(error, 'getDispositivosStatus');
    } finally {

      let tempo_refresh = 30000;
      // Evita consumo de internet excessivo quando o sistema é executado no servidor em nuvem
      if (this.isRemoteServer) {
        tempo_refresh = 30000;
      }/**/

      // Se nenhum dispositivo foi cadastrado, cancela o timer refresh
      if (!is404) {
        setTimeout(() => {
          this.getDispositivosStatus();
        }, tempo_refresh);
      }

    }

    return retorno;

  }

  async getDispositivosCadastradorFacial(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_dispositivos_cadastrador_facial",
        this.login.idCliente,
        params.searchQuery,
        this.login.conta.pk_idconta,
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

      this.loadDispositivo(retorno.response);

    } catch (error) {
      this.handleError(error, 'getDispositivosCadastradorFacial');
    }

    return retorno;

  }


  //#endregion

  //#region COMANDO

  checkComandos(body: any) {

    if (body.com_locais) {
      body.com_locais = body.com_locais.toString(); // array.toString(); // '1,2,3'
    }

    if (body.com_modofuncionamento) {
      body.com_modofuncionamento = body.com_modofuncionamento.toString(); // array.toString(); // '1,2,3'
    }

  }

  async loadComando(body: any) {


    body.forEach(o => {
      try {

        if (o.com_configuracoes) {
          o.com_configuracoes = this.stringToJSON(o.com_configuracoes);


        }

        if (o.com_locais) {
          // convert to array of int        
          o.com_locais = o.com_locais.split(',').map(function (item) {
            return parseInt(item, 10);
          });

          o.locaisdeacesso_json = this.stringToJSON(o.locaisdeacesso_json);
        }

        if (o.com_modofuncionamento) {
          // convert to array of int        
          o.com_modofuncionamento = o.com_modofuncionamento.split(',').map(function (item) {
            return parseInt(item, 10);
          });

        }


      } catch (error) {
        console.log(error);
      }

    });

  }

  /**
   * Comandos
   * @param operation 
   * @param result 
   */

  async createComando(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "comandos/";

      this.checkComandos(body);

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'createComandos');
    }

    return retorno;

  }

  async updateComando(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "comandos/" + id;

      this.checkComandos(body);

      retorno = await this.http.put<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'updateComandos');
    }

    return retorno;

  }

  async patchComando(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "comandos/" + id;

      retorno = await this.http.patch<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'patchComandos');
    }

    return retorno;

  }

  async removeComando(id: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "comandos/" + id;

      await this.http.delete<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'removeComandos');
    }

    return retorno;

  }

  async getComandoPorID(id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_comando_por_id",
        this.login.idCliente,
        id
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

      this.loadComando(retorno.response);

    } catch (error) {
      this.handleError(error, 'getComandosPorID');
    }

    return retorno;

  }

  async getComandos(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_comandos_list",
        this.login.idCliente,
        params.searchQuery,
        params.idmodelo, // id empresa
        params.locais ? params.locais.toString() : null, // locais de acesso separado por virgula .toString(); // array.toString(); // '1,2,3'    
        params.status_online.length == 2 ? null : params.status_online[0], // ON-line / OFF-line
        (!params.status || params.status.length == 2) ? null : params.status[0],
        this.login.conta.pk_idconta,
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getComandos');
    }

    return retorno;

  }

  async getComandosPorIDDispositivo(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_comandos_por_dispositivo",
        this.login.idCliente,
        params.iddispositivo,
        params.idtipocomando,
        !params.enviado || params.enviado.length == 2 ? null : params.enviado[0],
        !params.status || (!params.status || params.status.length == 2) ? null : params.status[0],
        this.login.conta.pk_idconta,
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

      this.loadComando(retorno.response);

    } catch (error) {
      this.handleError(error, 'getComandosPorIDDispositivo');
    }

    return retorno;

  }



  //#endregion

  //#region DISPOSITIVO_LOG

  async getDispositivoLogsPorIDDispositivo(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {
      var urlAPI = null
      var body = null
      var headers = await this.getHeaders();

      /**
       * Cliente no utiliza modo de conexao direta (CLOUD)
       */
      if (this.login.cli_modoconexao == 'D') {

        urlAPI = `${environment.API_URL_GCP}dispositivologs/filter?limit=${this.getRowLimit}&offset=${params.offset}`

        body = {
          search: params.searchQuery,
          fk_idcliente: this.login.idCliente,
          fk_iddispositivo: params.iddispositivo,
          orderby: params.sortBy,
          direction: params.sortDesc ? 'desc' : 'asc'

        }

        headers.Authorization = environment.TEMP_TOKEN_GCP;

      } else {

        urlAPI = this.urlServerAPI + "sql_views";

        body = [
          "view_dispositivologs_por_dispositivo",
          this.login.idCliente,
          params.iddispositivo,
          params.searchQuery,
          this.getRowLimit, //max_limit INT, 
          params.offset,
          params.sortBy,
          params.sortDesc ? 'DESC' : 'ASC'

        ]
      }


      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

      this.loadDispositivo(retorno.response);

    } catch (error) {
      this.handleError(error, 'getDispositivoLogsPorIDDispositivo');
    }

    return retorno;

  }


  async removeDispositivoLogsPor(idDispositivo: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "delete_dispositivologs",
        this.login.idCliente,
        idDispositivo
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();


    } catch (error) {
      this.handleError(error, 'removeDispositivoLogsPor');
    }

    return retorno;

  }

  //#endregion

  //#region EMPRESA

  checkFornecedor(body: any) {

    if (body.for_locaisdeacesso) {
      body.for_locaisdeacesso = body.for_locaisdeacesso.toString(); // array.toString(); // '1,2,3'    

      if (body.for_locaisdeacesso == '0') {
        body.for_locaisdeacesso = null;
      }
    }



  }

  loadFornecedor(response: any) {

    if (response) {
      response.forEach(o => {

        try {
          if (o.locaisdeacesso_json) {
            o.locaisdeacesso_json = this.stringToJSON(o.locaisdeacesso_json);
          }

        } catch (error) {
          console.log('loadFornecedor: ' + error);
        }

      });
    }


  }


  /**
   * FORNECEDOR - Serviços de refeição
   * @param operation 
   * @param result 
   */

  async createFornecedor(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "fornecedores/";

      this.checkFornecedor(body);

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'createFornecedor');
    }

    return retorno;

  }

  async updateFornecedor(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "fornecedores/" + id;

      this.checkFornecedor(body);

      retorno = await this.http.patch<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'updateFornecedor');
    }

    return retorno;

  }

  async patchFornecedor(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "fornecedores/" + id;

      this.checkFornecedor(body);

      retorno = await this.http.patch<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'patchFornecedor');
    }

    return retorno;

  }


  async removeFornecedor(id: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "fornecedores/" + id;

      await this.http.delete<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'removeFornecedor');
    }

    return retorno;

  }

  async getFornecedorPorID(id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_fornecedor_por_id", // rg
        this.login.idCliente,
        id
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

      this.loadFornecedor(retorno.response)

    } catch (error) {
      this.handleError(error, 'getFornecedorPorID');
    }

    return retorno;

  }

  async getFornecedores(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_fornecedores",
        this.login.idCliente,
        this.login.conta.pk_idconta,
        params.searchQuery,
        (!params.status || params.status.length == 2) ? null : params.status[0],
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getFornecedores');
    }

    return retorno;

  }
  //#endregion

  //#region SERVICO
  checkServico(body: any) {

    if (body.ser_valor) {
      body.ser_valor = body.ser_valor.replace(',', '.');
    }

  }

  async createServico(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "servicos/";

      this.checkServico(body);

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'createServico');
    }

    return retorno;

  }

  async updateServico(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "servicos/" + id;

      this.checkServico(body);

      retorno = await this.http.patch<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'updateServico');
    }

    return retorno;

  }

  async patchServico(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "servicos/" + id;

      this.checkServico(body);

      retorno = await this.http.patch<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'patchServico');
    }

    return retorno;

  }

  async removeServico(id: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "servicos/" + id;

      await this.http.delete<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'removeServico');
    }

    return retorno;

  }

  async getServicoPorID(id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "servicos/" + id;

      retorno = await this.http.get<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getServicoPorID');
    }

    return retorno;

  }

  async getServicos(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_servicos",
        this.login.idCliente,
        params.searchQuery,
        params.fornecedor,
        (!params.status || params.status.length == 2) ? null : params.status[0],
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getServicos');
    }

    return retorno;

  }

  //#endregion

  //#region TIPO_SERVICO
  checkTipoServico(body: any) {

  }

  /**
   * TipoServicos de Telefonia
   * @param operation 
   * @param result 
   */

  async createTipoServico(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "tiposervicos/";

      this.checkTipoServico(body);

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'createTipoServico');
    }

    return retorno;

  }

  async updateTipoServico(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "tiposervicos/" + body.pk_idtiposervico;

      this.checkTipoServico(body);

      retorno = await this.http.put<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'updateTipoServico');
    }

    return retorno;

  }

  async patchTipoServico(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "tiposervicos/" + body.pk_idtiposervico;

      retorno = await this.http.patch<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'patchTipoServico');
    }

    return retorno;

  }

  async removeTipoServico(id: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "tiposervicos/" + id;

      await this.http.delete<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'removeTipoServico');
    }

    return retorno;

  }

  async getTipoServicoPorID(id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "tiposervicos/" + id;

      retorno = await this.http.get<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

      let data = retorno.response[0];

    } catch (error) {
      this.handleError(error, 'getTipoServicoPorID');
    }

    return retorno;

  }

  async getTiposServicos(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_tipo_servicos",
        this.login.idCliente,
        params.searchQuery,
        (!params.status || params.status.length == 2) ? null : params.status[0],
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getTiposServicos');
    }

    return retorno;

  }
  //#endregion


  //#region DICIONARIO

  hasDic(dicEnum: any) {

    let retorno: boolean = false;

    if (this.login) {

      // https://stackoverflow.com/questions/4775722/how-to-check-if-an-object-is-an-array?rq=1
      if (Object.prototype.toString.call(dicEnum) === '[object Array]') {

        for (let index = 0; index < dicEnum.length; index++) {
          const o = dicEnum[index];

          if (this.login.temPermissao(o, 'R')) {
            retorno = true;
            break;
          }

        }

      } else {
        retorno = this.login.temPermissao(dicEnum, 'R');
      }
    }

    return retorno;
  }

  checkDicionarios(body: any) {



  }

  /**
   * Dicionarioss de Usuário
   * @param operation 
   * @param result 
   */

  async createDicionario(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "dicionarios/";

      this.checkDicionarios(body);

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'createDicionario');
    }

    return retorno;

  }

  async updateDicionario(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "dicionarios/" + id;

      this.checkDicionarios(body);

      retorno = await this.http.put<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'updateDicionario');
    }

    return retorno;

  }

  async patchDicionario(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "dicionarios/" + id;

      retorno = await this.http.patch<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'patchDicionario');
    }

    return retorno;

  }

  async removeDicionario(id: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "dicionarios/" + id;

      await this.http.delete<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'removeDicionario');
    }

    return retorno;

  }

  async getDicionarioPorID(id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "dicionarios/" + id;

      retorno = await this.http.get<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

      let data = retorno.response[0];

    } catch (error) {
      this.handleError(error, 'getDicionarioPorID');
    }

    return retorno;

  }

  async getDicionarios(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_dicionarios",
        this.login.idCliente,
        params.searchQuery,
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getDicionarios');
    }

    return retorno;

  }
  //#endregion

  //#region SINCRONISMO

  async getStatusSincronismoPorIDDispositivo(id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "status_sincronismo",
        //this.login.idCliente,
        id
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getStatusSincronismoPorIDDispositivo');
    }

    return retorno;

  }

  //#endregion

  //#region  Auditoria

  async getAuditoriaPorDicionarioEId(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_auditoria_por_dicionario_e_id",
        this.login.idCliente, // pk_idcliente INT, 
        params.fk_iddicionario,
        params.aud_idtabela,
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getAuditoriaPorDicionarioEId');
    }

    return retorno;

  }
  //#endregion

  //#region SQL_VIEWS

  async updateStatus(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "update_status",
        this.login.idCliente,
        this.login.conta.pk_idconta,
        params.fk_iddicionario,
        params.ids_array,
        params.status,
        params.table_name,
        params.table_status_name
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'updateStatus');
    }

    return retorno;

  }

  //#endregion

  //#region PESQUISA
  async buscaRapida(search: string): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "busca_rapida",
        this.login.idCliente, // pk_idcliente INT, 
        search, // VARCHAR, 
        this.getRowLimit, //max_limit INT, 
        0 // pos_offset INT,       
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'buscaRapida');
    }

    return retorno;

  }

  //#endregion

  //#region HISTORICO
  async createHistorico(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "historicos/";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'createHistorico');
    }

    return retorno;

  }

  async getHistoricoDeAcessos(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_historico",
        this.login.idCliente, // pk_idcliente INT, 
        params.searchQuery,
        params.liberado,
        this.login.idConta,
        params.con_locais,
        params.datahora,
        this.getRowLimit, //max_limit INT, 
        params.offset // pos_offset INT,       
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getHistoricoDeAcessos');
    }

    return retorno;

  }


  async getHistoricoDeRefeicoes(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_refeicoes",
        this.login.idCliente, // pk_idcliente INT, 
        params.empresa > 0 ? params.empresa : 0,// id empresa
        params.setor > 0 ? params.setor : 0,// id setor
        params.searchQuery,
        this.login.idConta,
        params.servico > 0 ? params.servico : 0,
        params.fornecedor > 0 ? params.fornecedor : 0,
        params.localAcesso > 0 ? params.localAcesso : 0,
        params.dataInicio,
        params.dataFim,
        this.getRowLimit, //max_limit INT, 
        params.offset // pos_offset INT,       
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getHistoricoDeRefeicoes');
    }

    return retorno;

  }

  async getHistoricoDeAcessosManuais(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_acessos_manuais",
        this.login.idCliente, // pk_idcliente INT, 
        params.empresa > 0 ? params.empresa : 0,// id empresa
        params.setor > 0 ? params.setor : 0,// id setor
        params.searchQuery,
        this.login.idConta,
        params.localAcesso > 0 ? params.localAcesso : 0,
        params.dataInicio,
        params.dataFim,
        this.getRowLimit, //max_limit INT, 
        params.offset // pos_offset INT,       
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getHistoricoDeAcessosManuais');
    }

    return retorno;

  }

  async getUltimosAcessos(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_ultimos_acessos",
        this.login.idCliente, // pk_idcliente INT, 
        params.idusuario > 0 ? params.idusuario : 0,
        params.idtag > 0 ? params.idtag : 0,
        params.idbiometria > 0 ? params.idbiometria : 0,
        params.idveiculo > 0 ? params.idveiculo : 0,
        this.getRowLimit, //max_limit INT, 
        params.offset // pos_offset INT,       
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getUltimosAcessos');
    }

    return retorno;

  }

  async getHistoricosPorIDDispositivo(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_historicos_por_dispositivo",
        this.login.idCliente,
        params.iddispositivo,
        params.searchQuery,
        params.situacao != "-1" ? params.situacao : null, // liberado ou bloqueado
        null, // data
        this.getRowLimit, //max_limit INT, 
        params.offset
        //params.sortBy,
        //params.sortDesc ? 'DESC' : 'ASC'

      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

      this.loadDispositivo(retorno.response);

    } catch (error) {
      this.handleError(error, 'getHistoricosPorIDDispositivo');
    }

    return retorno;

  }


  //#endregion

  //#region UPLOAD

  uploadFile(folders: any, fileName: string, file: File): Observable<any> {

    var retorno = null;

    try {

      // https://stackoverflow.com/questions/47034375/angular-file-upload-progress-percentage
      // https://www.itsolutionstuff.com/post/angular-9-file-upload-exampleexample.html
      // https://www.positronx.io/angular-file-upload-with-progress-bar-tutorial/
      const headers: any = this.headers;

      const urlAPI = this.urlServerAPI + "uploader";

      let parameters = {
        folders: folders,
        fileName: fileName
      }

      let formData = new FormData();
      formData.append('parameters', JSON.stringify(parameters));
      formData.append('file', file, file.name);

      // https://www.bennadel.com/blog/3596-uploading-multiple-files-in-a-single-form-post-with-httpclient-in-angular-7-2-12.htm
      // NOTE: When using a FormData instance to define the request BODY, the
      // correct Content-Type will be automatically provided, along with the
      // necessary "boundary" option that delimits the field values. If you
      // attempt to define the Content-Type explicitly, the "boundary" value
      // will be omitted from the post which will prevent the Lucee Server
      // parsing the request into the Form scope properly.
      // --
      // {
      // headers: {
      // "Content-Type": "multipart/form-data"
      // }
      // }
      delete headers['Content-Type'];

      retorno = this.http.post<ApiResponse>(urlAPI, formData, {
        headers,
        reportProgress: true,
        observe: 'events',
        responseType: "json"
      }).pipe(map((event: HttpEvent<any>) => {

        switch (event.type) {

          case HttpEventType.Sent:
            // start upload
            return {
              status: 'progress', message: 0
            };

          case HttpEventType.UploadProgress:
            // uploading
            const progress = Math.round(100 * event.loaded / event.total);
            return {
              status: 'progress', message: progress
            };

          case HttpEventType.Response:

            // complete upload
            return {
              status: 'OK', message: 0
            };

          default:
            return `Unhandled event: ${event.type}`;
        }

      }));

    } catch (error) {
      this.handleError(error, 'uploadFile');
    }

    return retorno;
  }

  //#endregion

  //#region STORAGE_LOCAL
  async getStorageLocal(key: string): Promise<any> {

    var retorno = null;

    try {
      retorno = await this.storage.get(key).toPromise();
    } catch (error) {
      this.handleError(error, 'getStorageLocal');
    }

    return retorno;

  }

  setStorageLocal(key: string, value: any) {

    this.storage.set(key, value).subscribe({
      next: () => { },
      error: (error) => {
        console.error('setStorageLocal: ' + error);
      },
    });

  }

  clearStorageLocal() {

    this.storage.clear().subscribe(() => { });

  }

  //#endregion

  //#region SMS
  async sendSMS(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      for (let index = 0; index < params.telefones.length; index++) {

        const numero = "+55" + params.telefones[index];

        const headers = await this.getHeaders();

        var body = {
          "PhoneNumber": numero,
          "Message": params.message
        }

        const urlAPI = this.urlServerAPI + "send_sms";

        retorno = await this.http.post<ApiResponse>(urlAPI, body, {
          headers
        }).toPromise();

      }

    } catch (error) {
      this.handleError(error, 'sendSMS');
    }

    return retorno;

  }

  //#endregion

  //#region RELATORIOS

  async loadRelatorioPessoasPorLocal(response) {

    if (response) {
      response.forEach(o => {

        try {
          if (o.locaisdeacesso_json) {
            o.locaisdeacesso_json = this.stringToJSON(o.locaisdeacesso_json);
          }

        } catch (error) {
          console.log('loadRelatorioPessoasPorLocal: ' + error);
        }

      });
    }
  }

  async getRelatorioPessoasPorLocal(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "rel_pessoa_local",
        this.login.idCliente,
        params.searchQuery,
        params.localAcesso && params.localAcesso[0] > 0 ? params.localAcesso.toString() : null, //separado por virgula .toString(); // array.toString(); // '1,2,3'    
        params.empresa && params.empresa[0] != '0' ? params.empresa.toString() : null, //separado por virgula .toString(); // array.toString(); // '1,2,3'
        params.setor, // id setor
        params.tiposAcessos && params.tiposAcessos[0] > 0 ? params.tiposAcessos.toString() : null, //separado por virgula .toString(); // array.toString(); // '1,2,3'    
        params.tiposPessoas && params.tiposPessoas[0] > 0 ? params.tiposPessoas.toString() : null, //separado por virgula .toString(); // array.toString(); // '1,2,3'    
        (!params.status || params.status.length == 2) ? null : params.status[0],
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

      this.loadRelatorioPessoasPorLocal(retorno.response)


    } catch (error) {
      this.handleError(error, 'getRelatorioTags');
    }

    return retorno;

  }

  async getRelatorioTags(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "rel_tag",
        this.login.idCliente,
        params.searchQuery,
        params.empresa && params.empresa[0] != '0' ? params.empresa.toString() : null, //separado por virgula .toString(); // array.toString(); // '1,2,3'
        params.setor, // id setor
        params.tiposAcessos && params.tiposAcessos[0] > 0 ? params.tiposAcessos.toString() : null, //separado por virgula .toString(); // array.toString(); // '1,2,3'    
        params.tiposPessoas && params.tiposPessoas[0] > 0 ? params.tiposPessoas.toString() : null, //separado por virgula .toString(); // array.toString(); // '1,2,3'    
        (!params.status || params.status.length == 2) ? null : params.status[0],
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getRelatorioTags');
    }

    return retorno;

  }

  async getRelatorioPessoas(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "rel_pessoas",
        this.login.idCliente,
        params.empresa && params.empresa[0] != '0' ? params.empresa.toString() : null, //separado por virgula .toString(); // array.toString(); // '1,2,3'
        params.setor, // id setor
        params.vinculo,
        params.poderes,
        params.tiposPessoas && params.tiposPessoas[0] > 0 ? params.tiposPessoas.toString() : null, //separado por virgula .toString(); // array.toString(); // '1,2,3'    
        params.idade,
        params.filtro_direcao_idade,
        (!params.status || params.status.length == 2) ? null : params.status[0],
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy.toString(),
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getRelatorioPessoas');
    }

    return retorno;

  }


  async getRelatorioAcessosInfrequentes(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "rel_acessos_infrequentes",
        this.login.idCliente,
        params.empresa && params.empresa[0] != '0' ? params.empresa.toString() : null, //separado por virgula .toString(); // array.toString(); // '1,2,3'
        params.setor, // id setor
        params.vinculo,
        params.poderes,
        params.tiposPessoas && params.tiposPessoas[0] > 0 ? params.tiposPessoas.toString() : null, //separado por virgula .toString(); // array.toString(); // '1,2,3'    
        params.idade,
        params.filtro_direcao_idade,
        params.numero_dias,
        (!params.status || params.status.length == 2) ? null : params.status[0],
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy.toString(),
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getRelatorioAcessosInfrequentes');
    }

    return retorno;

  }

  async getRelatorioTelefones(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "rel_telefone",
        this.login.idCliente,
        params.empresa && params.empresa[0] != '0' ? params.empresa.toString() : null, //separado por virgula .toString(); // array.toString(); // '1,2,3'
        params.setor, // id setor
        params.vinculo,
        //params.tiposPessoas && params.tiposPessoas[0] > 0  ? params.tiposPessoas.toString() : null, //separado por virgula .toString(); // array.toString(); // '1,2,3'    
        params.tiposPessoas,
        (!params.status || params.status.length == 2) ? null : params.status[0],
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy.toString(),
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getRelatorioTelefones');
    }

    return retorno;

  }

  async getRelatorioVeiculos(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "rel_veiculo",
        this.login.idCliente,
        params.empresa && params.empresa[0] != '0' ? params.empresa.toString() : null, //separado por virgula .toString(); // array.toString(); // '1,2,3'
        params.setor, // id setor
        params.vinculo,
        params.tiposPessoas && params.tiposPessoas[0] > 0 ? params.tiposPessoas.toString() : null, //separado por virgula .toString(); // array.toString(); // '1,2,3'    
        params.tipoVeiculo.length == 0 ? null : params.tipoVeiculo, // Moto ou Carro
        params.semTag.length == 0 ? null : params.semTag, // Com ou sem TAG
        (!params.status || params.status.length == 2) ? null : params.status[0],
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy.toString(),
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getRelatorioVeiculos');
    }

    return retorno;

  }

  async getRelatorioVisitantes(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "rel_visitante",
        this.login.idCliente,
        params.empresa && params.empresa[0] != '0' ? params.empresa.toString() : null, //separado por virgula .toString(); // array.toString(); // '1,2,3'
        params.setor, // id setor
        params.autorizadoPor > 0 ? params.autorizadoPor : 0,
        params.operador > 0 ? params.operador : 0,
        params.vinculo,
        params.situacao,
        params.dataInicio + "T" + params.horaInicio + ":00",
        params.dataFim + "T" + params.horaFim + ":59",
        (!params.status || params.status.length == 2) ? null : params.status[0],
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy.toString(),
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getRelatorioVisitantes');
    }

    return retorno;

  }

  async getRelatorioCartoesUsados(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "rel_cartao_usado",
        this.login.idCliente,
        params.empresa && params.empresa[0] != '0' ? params.empresa.toString() : null, //separado por virgula .toString(); // array.toString(); // '1,2,3'
        params.setor, // id setor
        params.autorizadoPor > 0 ? params.autorizadoPor : 0,
        null,
        params.operador > 0 ? params.operador : 0,
        params.vinculo,
        params.situacao != "-2" ? params.situacao : null,
        params.dataInicio + "T" + params.horaInicio + ":00",
        params.dataFim + "T" + params.horaFim + ":59",
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy.toString(),
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getRelatorioCartoesUsados');
    }

    return retorno;

  }

  async getRelatorioBloqueios(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "rel_bloqueio",
        this.login.idCliente,
        params.empresa && params.empresa[0] != '0' ? params.empresa.toString() : null, //separado por virgula .toString(); // array.toString(); // '1,2,3'
        params.setor, // id setor
        params.operador > 0 ? params.operador : 0,
        params.motivo > 0 ? params.motivo : 0,
        (!params.status || params.status.length == 2) ? null : params.status[0],
        params.dataInicio + "T" + params.horaInicio + ":00",
        params.dataFim + "T" + params.horaFim + ":59",
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy.toString(),
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getRelatorioBloqueios');
    }

    return retorno;

  }

  async getRelatorioHistoricos(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "rel_principal",
        this.login.idCliente,
        params.searchQuery,
        params.tiposAcessos && params.tiposAcessos[0] != 0 ? params.tiposAcessos.toString() : null, //separado por virgula .toString(); // array.toString(); // '1,2,3'    
        params.tiposPessoas && params.tiposPessoas[0] > 0 ? params.tiposPessoas.toString() : null, //separado por virgula .toString(); // array.toString(); // '1,2,3'    
        params.empresa && params.empresa[0] != '0' ? params.empresa.toString() : null, //separado por virgula .toString(); // array.toString(); // '1,2,3'
        params.setor, // id grupo
        params.vinculo > 0 ? params.vinculo : 0,
        params.localAcesso && params.localAcesso[0] > 0 ? params.localAcesso.toString() : null, //separado por virgula .toString(); // array.toString(); // '1,2,3'    
        params.operador > 0 ? params.operador : 0,
        params.dataInicio + "T" + params.horaInicio + ":00",
        params.dataFim + "T" + params.horaFim + ":59",
        params.situacao != "-1" ? params.situacao : null,
        params.rowLimit ? params.rowLimit : this.getRowLimit, //max_limit INT,
        params.offset,
        params.sortBy.toString(),
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getRelatorioHistoricos');
    }

    return retorno;

  }

  async getRelatorioAuditorias(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "rel_auditoria",
        this.login.idCliente,
        params.operador > 0 ? params.operador : 0,
        params.dicionario,
        params.crud != '0' ? params.crud : null,
        params.dataInicio + "T" + params.horaInicio + ":00",
        params.dataFim + "T" + params.horaFim + ":59",
        params.gerar_estatistica,
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy.toString(),
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getRelatorioAuditorias');
    }

    return retorno;

  }

  async getRelatorioComandos(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "rel_comando",
        this.login.idCliente,
        params.operador > 0 ? params.operador : 0,
        params.tipoComando > 0 ? params.tipoComando : 0,
        params.dispositivo > 0 ? params.dispositivo : 0,
        params.dataInicio + "T" + params.horaInicio + ":00",
        params.dataFim + "T" + params.horaFim + ":59",
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy.toString(),
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getRelatorioComandos');
    }

    return retorno;

  }

  async getRelatorioLogins(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "rel_login",
        this.login.idCliente,
        params.operador > 0 ? params.operador : 0,
        params.sentido != '' ? params.sentido : null,
        params.dataInicio + "T" + params.horaInicio + ":00",
        params.dataFim + "T" + params.horaFim + ":59",
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy.toString(),
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getRelatorioLogins');
    }

    return retorno;

  }

  async getRelatorioRefeitorios(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "rel_refeitorio",
        this.login.idCliente,
        params.empresa, // id empresa
        params.setor, // id setor
        params.searchQuery,
        params.servico > 0 ? params.servico : 0,
        params.fornecedor > 0 ? params.fornecedor : 0,
        params.vinculo > 0 ? params.vinculo : 0,
        params.localAcesso && params.localAcesso[0] > 0 ? params.localAcesso.toString() : null, //separado por virgula .toString(); // array.toString(); // '1,2,3'    
        params.pessoa > 0 ? params.pessoa : 0,
        params.operador > 0 ? params.operador : 0,

        params.tiposPessoas && params.tiposPessoas[0] > 0 ? params.tiposPessoas.toString() : null, //separado por virgula .toString(); // array.toString(); // '1,2,3'    
        params.dataInicio + "T" + params.horaInicio + ":00",
        params.dataFim + "T" + params.horaFim + ":59",
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy.toString(),
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getRelatorioRefeitorios');
    }

    return retorno;

  }

  async getEstatisticasPorSetor(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "rel_qtdtagsetor",
        this.login.idCliente,
        params.empresa > 0 ? params.empresa : 0,// id empresa
        params.setor > 0 ? params.setor : 0,// id setor
        params.tiposAcessos && params.tiposAcessos[0] > 0 ? params.tiposAcessos.toString() : null, //separado por virgula .toString(); // array.toString(); // '1,2,3'    
        (!params.status || params.status.length == 2) ? null : params.status[0],
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy.toString(),
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getEstatisticasPorSetor');
    }

    return retorno;

  }

  async getEstatisticasPorEmpresa(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "rel_qtdtagempresa",
        this.login.idCliente,
        params.empresa > 0 ? params.empresa : 0,// id empresa
        params.tiposAcessos && params.tiposAcessos[0] > 0 ? params.tiposAcessos.toString() : null, //separado por virgula .toString(); // array.toString(); // '1,2,3'    
        (!params.status || params.status.length == 2) ? null : params.status[0],
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy.toString(),
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getEstatisticasPorEmpresa');
    }

    return retorno;

  }

  async getEstatisticasPorPessoaEmpresa(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "rel_qtdpessoaempresa",
        this.login.idCliente,
        params.empresa > 0 ? params.empresa : 0,// id empresa
        params.tiposPessoas && params.tiposPessoas[0] > 0 ? params.tiposPessoas.toString() : null, //separado por virgula .toString(); // array.toString(); // '1,2,3'    
        params.validade,
        (!params.status || params.status.length == 2) ? null : params.status[0],
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy.toString(),
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getEstatisticasPorPessoaEmpresa');
    }

    return retorno;

  }

  async getEstatisticasPorPessoaSetor(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "rel_qtdpessoasetor",
        this.login.idCliente,
        params.empresa > 0 ? params.empresa : 0,// id empresa
        params.setor > 0 ? params.setor : 0,// id setor
        params.tiposPessoas && params.tiposPessoas[0] > 0 ? params.tiposPessoas.toString() : null, //separado por virgula .toString(); // array.toString(); // '1,2,3'    
        params.validade,
        (!params.status || params.status.length == 2) ? null : params.status[0],
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy.toString(),
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getEstatisticasPorPessoaSetor');
    }

    return retorno;

  }

  async getRelatorioUnidadesOcupadas(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_unidades_ocupadas",
        this.login.idCliente,
        params.searchQuery,
        params.situacao != "-2" ? params.situacao : null,
        params.tiposPessoas && params.tiposPessoas[0] > 0 ? params.tiposPessoas.toString() : null, //separado por virgula .toString(); // array.toString(); // '1,2,3'    
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getRelatorioUnidadesOcupadas');
    }

    return retorno;

  }

  async getRelatorioVagasOcupadas(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_vagas_ocupadas",
        this.login.idCliente,
        //params.searchQuery,
        //params.situacao != "-2" ? params.situacao : null,
        params.tiposPessoas && params.tiposPessoas[0] > 0 ? params.tiposPessoas.toString() : null, //separado por virgula .toString(); // array.toString(); // '1,2,3'    
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getRelatorioVagasOcupadas');
    }

    return retorno;

  }

  //#endregion

  //#region IMPORTACOES
  async importClientes(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "import_clientes",
        this.login.idCliente,
        params.rows
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'importClientes');
    }

    return retorno;

  }

  async importPessoas(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "usuario_bulk_insert",
        this.login.idCliente,
        params.rows
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'importPessoas');
    }

    return retorno;

  }
  //#endregion


  //#region API_TERCEIROS

  // https://github.com/filipedeschamps/cep-promise
  // consulta três serviços simultaneamente e retorna o primeiro que responder
  // a fazer
  async buscarCEP(cep: string): Promise<any> {

    var retorno = null;

    try {

      retorno = await this.http.get(`https://viacep.com.br/ws/${cep}/json/`).toPromise();

      // upperCase
      this.toUpperCase(retorno);

    } catch (error) {
      this.handleError(error, 'buscarCEP');
    }

    return retorno;

  }

  // https://receitaws.com.br/
  async buscarCNPJ(cnpj: string): Promise<any> {

    var retorno = null;

    try {

      /*let headers = {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Headers': 'Content-Type',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Credentials': 'true',
        'Access-Control-Max-Age': '86400', // cache for 1 day
        'Cookie': 'JSESSIONID=0e410cf8f1a222e61c620e689abdb9b5b3ce8428'
      }/**/

      retorno = await this.http.get(`https://cors-anywhere.herokuapp.com/http://www.receitaws.com.br/v1/cnpj/${cnpj}`).toPromise();

      /*retorno = await this.http.get(`https://www.receitaws.com.br/v1/cnpj/${cnpj}`, {
        headers
      }).toPromise();/**/

    } catch (error) {
      this.handleError(error, 'buscarCNPJ');
    }

    return retorno;

  }

  //#endregion


  //#region LOCAL_EVENTOS

  checkLocalEventos(body: any) {

    if (body.fk_idempresa != null) {
      body.fk_idempresa = body.fk_idempresa > 0 ? body.fk_idempresa : null;
    }
  }

  /**
   * LocalEventoss de Usuário
   * @param operation 
   * @param result 
   */

  async createLocalEvento(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "localeventos/";

      this.checkLocalEventos(body);

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'createLocalEvento');
    }

    return retorno;

  }

  async updateLocalEvento(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "localeventos/" + id;

      this.checkLocalEventos(body);

      retorno = await this.http.put<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'updateLocalEvento');
    }

    return retorno;

  }

  async patchLocalEvento(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "localeventos/" + id;

      this.checkLocalEventos(body);

      retorno = await this.http.patch<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'patchLocalEvento');
    }

    return retorno;

  }

  async removeLocalEvento(id: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "localeventos/" + id;

      await this.http.delete<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'removeLocalEvento');
    }

    return retorno;

  }

  async getLocalEventoPorID(id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "localeventos/" + id;

      retorno = await this.http.get<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getLocalEventosPorID');
    }

    return retorno;

  }

  async getLocalEventos(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_localeventos",
        this.login.idCliente,
        params.searchQuery,
        (!params.status || params.status.length == 2) ? null : params.status[0],
        this.login.conta.pk_idconta,
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getLocalEventos');
    }

    return retorno;

  }


  //#endregion

  //#region EVENTOS

  checkEventos(body: any) {

    if (body.fk_idempresa != null) {
      body.fk_idempresa = body.fk_idempresa > 0 ? body.fk_idempresa : null;
    }
  }

  /**
   * LocalEventoss de Usuário
   * @param operation 
   * @param result 
  */

  async createEvento(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "eventos/";

      this.checkEventos(body);

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'createEvento');
    }

    return retorno;

  }

  async updateEvento(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "eventos/" + id;

      this.checkEventos(body);

      retorno = await this.http.put<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'updateEvento');
    }

    return retorno;

  }

  async patchEvento(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "eventos/" + id;

      this.checkEventos(body);

      retorno = await this.http.patch<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'patchEvento');
    }

    return retorno;

  }

  async removeEvento(id: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "eventos/" + id;

      await this.http.delete<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'removeEvento');
    }

    return retorno;

  }

  async getEventoPorID(id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_evento_por_id",
        this.login.idCliente,
        id
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

      this.loadAviso(retorno.response);

    } catch (error) {
      this.handleError(error, 'getEventoPorID');
    }

    return retorno;

  }

  async getEventos(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_eventos",
        this.login.idCliente,
        params.searchQuery,
        params.locais ? params.locais.toString() : null, // locais de acesso separado por virgula .toString(); // array.toString(); // '1,2,3'    
        params.tipos ? params.tipos.toString() : null, // locais de acesso separado por virgula .toString(); // array.toString(); // '1,2,3'    
        params.listas ? params.listas.toString() : null, // locais de acesso separado por virgula .toString(); // array.toString(); // '1,2,3'    
        (!params.status || params.status.length == 2) ? null : params.status[0],
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getEventos');
    }

    return retorno;

  }

  //#endregion



  //#region DASHBOARDS
  async getDashboard_1(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "dashboard_1",
        this.login.idCliente,
        this.login.conta.pk_idconta
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getDashboard_1');
    }

    return retorno;

  }

  async getDashboard_refeitorio(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "dashboard_refeitorio",
        this.login.idCliente,
        this.login.conta.pk_idconta,
        params.interval_periodo // String ('{mês} months')
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getDashboard_refeitorio');
    }

    return retorno;

  }

  async getDashboard_Ocupacao(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "dashboard_ocupacao",
        this.login.idCliente,
        this.login.conta.pk_idconta,
        params.empresa
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

      retorno.response.forEach(o => {

        o.qtd_entradas = 0;
        o.qtd_saidas = 0;

        if (o.acessos) {

          const jsonAcessos = JSON.parse(o.acessos)

          jsonAcessos.forEach(acesso => {

            if (acesso.his_sentido == 'E') {
              o.qtd_entradas = acesso.count
            } else {
              o.qtd_saidas = acesso.count
            }

          });

        }

        // Calculando ausentes
        o.qtd_ausentes = o.qtd_pessoas - (o.qtd_entradas + o.qtd_saidas)

      });


    } catch (error) {
      this.handleError(error, 'getDashboard_Ocupacao');
    }

    return retorno;

  }

  //#endregion



  //#region EVENTONOMES
  // *tipos de evento*

  checkEventoNome(body: any) {

  }

  /**
   * Operadoras de Telefonia
   * @param operation 
   * @param result 
   */

  async createEventoNome(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "eventonomes/";

      this.checkEventoNome(body);

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'createEventoNome');
    }

    return retorno;

  }

  async updateEventoNome(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "eventonomes/" + body.pk_ideventonome;

      this.checkEventoNome(body);

      retorno = await this.http.put<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'updateEventoNome');
    }

    return retorno;

  }

  async patchEventoNome(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "eventonomes/" + body.pk_ideventonome;

      retorno = await this.http.patch<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'patchEventoNome');
    }

    return retorno;

  }

  async removeEventoNome(id: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "eventonomes/" + id;

      await this.http.delete<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'removeEventoNome');
    }

    return retorno;

  }

  async getEventoNomePorID(id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "eventonomes/" + id;

      retorno = await this.http.get<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

      let data = retorno.response[0];

    } catch (error) {
      this.handleError(error, 'getEventoNomePorID');
    }

    return retorno;

  }

  async getEventoNomes(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_eventonomes",
        this.login.idCliente,
        params.searchQuery,
        (!params.status || params.status.length == 2) ? null : params.status[0],
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getEventoNomes');
    }

    return retorno;

  }
  //#endregion

  //#region TIPO_EVENTONOMES
  async getTipoEventoNomes(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_eventonomes",
        this.login.idCliente,
        params.searchQuery,
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getTipoEventoNomes');
    }

    return retorno;

  }
  //#endregion


  //#region AVISO

  checkAvisos(body: any) {


  }

  async loadAviso(body: any) {


    body.forEach(o => {
      try {




      } catch (error) {
        console.log(error);
      }

    });

  }

  /**
   * Avisos
   * @param operation 
   * @param result 
   */

  async createAviso(body: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "avisos/";

      this.checkAvisos(body);

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'createAvisos');
    }

    return retorno;

  }

  async updateAviso(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "avisos/" + id;

      this.checkAvisos(body);

      retorno = await this.http.put<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'updateAvisos');
    }

    return retorno;

  }

  async patchAviso(body: any, id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "avisos/" + id;

      retorno = await this.http.patch<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'patchAvisos');
    }

    return retorno;

  }

  async removeAviso(id: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      const urlAPI = this.urlServerAPI + "avisos/" + id;

      await this.http.delete<ApiResponse>(urlAPI, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'removeAvisos');
    }

    return retorno;

  }

  async getAvisoPorID(id: number): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_aviso_por_id",
        this.login.idCliente,
        id
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

      this.loadAviso(retorno.response);

    } catch (error) {
      this.handleError(error, 'getAvisosPorID');
    }

    return retorno;

  }

  async getAvisos(params: any): Promise<ApiResponse> {

    var retorno = null;

    try {

      const headers = await this.getHeaders();

      var body = [
        "view_avisos",
        this.login.idCliente,
        params.searchQuery,
        params.empresa, // id empresa
        params.setor, // id setor      
        params.operador,
        params.numerodias,
        params.tipo ? params.tipo : 'E', // Encomenda: 'E', Aviso: 'A'
        params.status_envio.length == 2 ? null : params.status_envio[0], // Enviador / Entregue
        (!params.status || params.status.length == 2) ? null : params.status[0],
        //this.login.conta.pk_idconta,
        this.getRowLimit, //max_limit INT, 
        params.offset,
        params.sortBy,
        params.sortDesc ? 'DESC' : 'ASC'
      ]

      const urlAPI = this.urlServerAPI + "sql_views";

      retorno = await this.http.post<ApiResponse>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'getAvisos');
    }

    return retorno;

  }


  //#endregion

  //#region PRINT


  async print(body: any): Promise<any> {

    var retorno = null;

    try {
      const headers = {
        'Content-Type': 'application/json'
      }

      // EX.: http://192.168.15.199:3030/print
      // Ex.: http://localhost:3030/print
      let urlServerPrint = (this.platformLocation as any).location.hostname

      const urlAPI = "http://" + urlServerPrint + ":3030/print"

      retorno = await this.http.post<any>(urlAPI, body, {
        headers
      }).toPromise();

    } catch (error) {
      this.handleError(error, 'print')
    }

    return retorno;

  }

  //#endregion



  //#region UTIL

  isNumber(n): any {
    let retorno = null;
    try {
      retorno = !isNaN(parseFloat(n)) && isFinite(n);
    } catch (error) {

    }
    return retorno;
  }

  padLeft(text: string, padChar: string, size: number): string {
    return (String(padChar).repeat(size) + text).substr((size * -1), size);
  }

  isCPF(strCPF): boolean {
    var Soma;
    var Resto;
    Soma = 0;
    if (strCPF == "00000000000") return false;

    for (let i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
    Resto = (Soma * 10) % 11;

    if ((Resto == 10) || (Resto == 11)) Resto = 0;
    if (Resto != parseInt(strCPF.substring(9, 10))) return false;

    Soma = 0;
    for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
    Resto = (Soma * 10) % 11;

    if ((Resto == 10) || (Resto == 11)) Resto = 0;
    if (Resto != parseInt(strCPF.substring(10, 11))) return false;
    return true;
  }

  /**
   * Handle Http operation that failed.
   * https://angular.io/tutorial/toh-pt6
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  handleError(error: any, operation: string): void {

    // TODO: send the error to remote logging infrastructure      

    // TODO: better job of transforming error for user consumption
    console.log(`${operation} failed: ${error.message}`);

    if (error.error && error.error.response) {
      console.log(`${operation}, Code: ${error.error.response.code}, Details: ${error.error.response.message}`);
    }

    if (error.status == 401 &&
      error.error &&
      error.error.response &&
      error.error.response.code == 1171) {

      // Registrando a saída do sistema para a conta do usuário logado atual
      this.logout(false);

      // get current url to return
      // Voltar para a tela anterior após login expirar
      let return_url = (this.platformLocation as any).location.pathname + (this.platformLocation as any).location.search;

      let href = (this.platformLocation as any).location.href

      if (href.indexOf('login') < 0) {
        // TokenExpiredError
        this.errorMessageShow(error);

        // Redirect to session expired
        // https://jasonwatmore.com/post/2016/12/08/angular-2-redirect-to-previous-url-after-login-with-auth-guard
        this.router.navigate(['/login/authentication/login-v2'], {
          queryParams: {
            returnUrl: return_url
          }
        });
      }

    }

    // return error
    throw error

  }

  parseToInt(value): number {
    let retorno: number = 0;

    try {
      if (value && value.length > 0) {
        retorno = parseInt(value);
      }

    } catch (error) {

    }

    return retorno;
  }

  stringToJSON(value): any {

    try {

      if (value) {
        value = JSON.parse(value);
      }

    } catch (error) {
      console.log(value)
      console.log(error)

    }

    return value;
  }

  jsonToString(value): any {

    try {

      if (value) {
        value = JSON.stringify(value);
      }

    } catch (error) {
      console.log(error);
    }

    return value;
  }

  /**
   * https://stackoverflow.com/questions/35754586/format-date-as-dd-mm-yyyy-using-pipes 
   * @param value The date expression: a `Date` object,  a number
   * (milliseconds since UTC epoch), or an ISO string (https://www.w3.org/TR/NOTE-datetime).
   * @param format The date/time components to include, using predefined options or a
   * custom format string.
   * shortDate: 31/05/2020
   * short: 31/05/2020 12:36
   * 
   */
  dateIsoToString(value, format = 'shortDate'): any {

    try {

      if (value) {
        var datePipe = new DatePipe("pt-BR"); // Use your own locale
        value = datePipe.transform(value, format);
      }

    } catch (error) {
      console.log(error);
    }

    return value;
  }

  today(): string {
    let today: number = Date.now();
    return this.dateIsoToString(today);
  }

  /**
   * https://stackoverflow.com/questions/43407338/how-to-add-hours-to-a-parse-moment-date/43407371
   * https://stackoverflow.com/questions/17333425/add-a-duration-to-a-moment-moment-js
   * @param minutes Pega a data atual e adiciona os minutos a hora atual
   */
  getDateAddMinute(minutes, format: string = 'YYYY-MM-DD') {

    let a = new Date();

    var startdate = moment(a);

    var returned_endate = moment(startdate).add(minutes, 'minutes');  // see the cloning?

    let b = (new DateFormatPipe()).transform(returned_endate, format);

    return b

  }

  getFormatDate(date, format: string = 'YYYY-MM-DD') {

    let a = Date.parse(date);

    let b = (new DateFormatPipe()).transform(a, format);

    return b

  }

  getDateAddDay(days, format: string = 'YYYY-MM-DD') {

    let a = new Date();

    var startdate = moment(a);

    var returned_endate = moment(startdate).add(days, 'days');  // see the cloning?

    let b = (new DateFormatPipe()).transform(returned_endate, format);

    return b

  }

  getDateAddHour(hours, format: string = 'YYYY-MM-DD') {

    let a = new Date();

    var startdate = moment(a);

    var returned_endate = moment(startdate).add(hours, 'hours');  // see the cloning?

    let b = (new DateFormatPipe()).transform(returned_endate, format);

    return b

  }

  getDateISO(format: string = 'YYYY-MM-DD'): string {
    // https://github.com/urish/ngx-moment/issues/158
    let a = new Date();
    let b = (new DateFormatPipe()).transform(a, format);
    return b;
  }

  getDateTimeISO(): string {

    return moment().format("YYYY-MM-DDTHH:mm:ss")

  }

  toUpperCase(data: any): any {

    try {

      if (!data)
        return null;

      if (typeof data === 'string' || data instanceof String) {
        data = data.toUpperCase();
      } else {
        // upperCase
        for (var key in data) {
          var value = data[key];

          if (value) {
            value = value.toUpperCase();
            data[key] = value;
          }
        }
      }

    } catch (error) {

    }

    return data;
  }

  // https://eloquentjavascript.net/09_regexp.html
  getOnlyNumbers(value) {
    if (value && value.length > 0) {
      // /\d/	Any digit character
      value = value.match(/\d/g).join("");
    }
    return value;
  }

  // https://eloquentjavascript.net/09_regexp.html
  getOnlyNumbersAndLetters(value) {
    if (value && value.length > 0) {
      // Allow numbers, alpahbets
      // /\w/	An alphanumeric character (“word character”
      value = value.match(/\w/g).join("");
    }
    return value;
  }

  isJson(str) {
    try {
      JSON.parse(str)

    } catch (e) { return false }

    return true
  }

  // Checa se o cliente é uma empresa ou condomínio
  // https://stackoverflow.com/questions/49843791/async-pipe-with-a-method-call-in-angular-4-calls-infinitely
  async translateEmpresa() {

    let retorno: string = null;

    const user = await this.getUser();

    if (user && user.configuracao_atual.traducao_perfil == 'c') {
      // C = Modo condominio: Torre/Apto
      retorno = this.translateService.instant("empresa.torre");
    } else {
      retorno = this.translateService.instant("empresa.empresa");
    }

    return retorno;


  }

  // Checa se o cliente é uma empresa ou condomínio
  // https://stackoverflow.com/questions/49843791/async-pipe-with-a-method-call-in-angular-4-calls-infinitely
  async translateSetor() {

    let retorno: string = null;

    const user = await this.getUser();

    if (user && user.configuracao_atual.traducao_perfil == 'c') {
      // C = Modo condominio: Torre/Apto
      retorno = this.translateService.instant("setor.apto");
    } else {
      retorno = this.translateService.instant("setor.setor");
    }

    return retorno;


  }

  public getUrlImage(image, refreshImage: boolean = false) {

    var retorno = null;

    if (image) {

      if (this.isRemoteServer) {
        // set foto
        retorno = image.remote_url_foto;
      } else {

        if (this.isDev) {
          let rootUrl = (this.platformLocation as any).location.protocol + "//" + (this.platformLocation as any).location.hostname;
          retorno = rootUrl + image.local_url_foto;
        } else {
          retorno = image.local_url_foto;
        }

        if (refreshImage) {
          retorno += '?' + (new Date()).getTime();
        }

      }
    }

    return retorno;
  }

  public generateUrlImage(folder, fileName, refreshImage: boolean = false, ext = ".jpg") {

    let image = {
      local_url_foto: "/upload/" + folder + "/" + fileName + ext,
      remote_url_foto: 'https://s3.amazonaws.com/s3-dant/dantacesso/' + (this.login.conta.fk_idcliente || 1) + "/" + folder + "/" + fileName + ext
    };

    return this.getUrlImage(image, refreshImage);

  }

  parseCurrencyFormat(value: any) {
    let retorno = value;

    try {

      if (typeof value === 'string' || value instanceof String) {

        retorno = parseFloat(value.toString()).toFixed(2);

      } else {
        retorno = value.toFixed(2);
      }

      // https://stackoverflow.com/questions/38752324/angular-2-formatting-currency-brl-format
      retorno = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(retorno);

    } catch (error) {
      console.error('parseCurrencyFormat: ' + error);
    }


    return retorno;
  }

  /** 
  * Compares two Date objects and returns e number value that represents 
  * the result:
  * 0 if the two dates are equal.
  * 1 if the first date is greater than second.
  * -1 if the first date is less than second.
  * @param date1 First date object to compare.
  * @param date2 Second date object to compare.
  */
  compareDate(date1: Date, date2: Date): number {
    // With Date object we can compare dates them using the >, <, <= or >=.
    // The ==, !=, ===, and !== operators require to use date.getTime(),
    // so we need to create a new instance of Date with 'new Date()'
    let d1 = new Date(date1); let d2 = new Date(date2);

    // Check if the dates are equal
    let same = d1.getTime() === d2.getTime();
    if (same) return 0;

    // Check if the first is greater than second
    if (d1 > d2) return 1;

    // Check if the first is less than second
    if (d1 < d2) return -1;
  }

  getFirstWord(value: string): string {
    if (value == null) {
      return value;
    }
    value = value.trim();
    const words = value.split(' ');
    return words.length > 0 ? words[0] : value;
  }

  removeSpacesAndAccent(value: string): string {

    if (value == null) {
      return value
    }

    value = value.trim().toUpperCase()
    // Remove double space 
    value = value.replace(/\s+/g, ' ')
    // Remove accent
    value = value.normalize('NFD').replace(/[\u0300-\u036f]/g, "")

    return value

  }

  removeAllSpacesAndAccent(value: string): string {

    if (value == null) {
      return value
    }

    value = value.trim().toUpperCase()
    // Remove all spaces
    value = value.replace(/\s+/g, '')
    // Remove accent
    value = value.normalize('NFD').replace(/[\u0300-\u036f]/g, "")

    return value

  }

  // https://flaviocopes.com/how-to-trim-leading-zero-number/
  removeZerosLeft(value: string): string {

    if (value == null) {
      return value
    }

    try {

      value = value.trim()

      // You can also go the regular expression route, like this:
      // number.replace(/^0+/, '')

      let number = parseInt(value, 10)
      value = number.toString()
    } catch (error) {

    }

    return value

  }

  //#endregion




  // REGION Help Video
  getVideos() {
    return [{
      image: 'logo_dantsistemas_alta_banner.png',
      title: 'Aviso de encomendas',
      description: 'Tutorial de como usar a ferramenta de aviso de encomendas.',
      price: '07:44',
      partialUrl: 'Vw0_Hqm4pOI',
      tag: 'Comunicações',
      id: 0
    }, {
      image: 'logo_dantsistemas_alta_banner.png',
      title: 'Cadastro de moradores',
      description: 'Tutorial de como cadastrar moradores.',
      price: '04:33',
      partialUrl: 'm3SmPCHj1t0',
      tag: 'Pessoas',
      id: 1
    }, {
      image: 'logo_dantsistemas_alta_banner.png',
      title: 'Cadastro de funcionário',
      description: 'Tutorial de como cadastrar funciários.',
      price: '02:30',
      partialUrl: 'c-V0sweEz3U',
      tag: 'Pessoas',
      id: 2
    }, {
      image: 'logo_dantsistemas_alta_banner.png',
      title: 'Cadastro de visitante',
      description: 'Tutorial de como cadastrar visitantes',
      price: '03:20',
      partialUrl: 'sYewF7fx69Q',
      tag: 'Pessoas',
      id: 3
    }, {
      image: 'logo_dantsistemas_alta_banner.png',
      title: 'Cadastro de QRCode',
      description: 'Tutorial de como cadastrar QRCode',
      price: '01:31',
      partialUrl: 'Gid3zJIR2XY',
      tag: 'Acesso',
      id: 4
    }, {
      image: 'logo_dantsistemas_alta_banner.png',
      title: 'Busca rápida',
      description: 'Tutorial de como funciona a ferramenta de busca rápida',
      price: '03:21',
      partialUrl: '34MI25aJC5g',
      tag: 'Ferramentas',
      id: 5
    }]
  }
  //#endregion

}
